<template>
  <div>
    <div v-if="Lib.checkPower('beauty-2-ckft',2)" v-loading="loading" element-loading-text="正在加载中...">
      <div v-show="first_loading" v-if="radio1 === '远期'" class="first_header">
        <div class="room_type">
          <div v-for="(item, index) in room_type" :key="index">
            <div class="room_type_color" :class="index == 0 ? 'room_type_border' : ''" :style="{ background: item.color }"></div>
            <span>{{ item.name }}</span>
          </div>
          <div>
            <i class="iconfont" style="font-size: 20px; color: #b4bccc;">&#xe621;</i>
            <span>已过期</span>
          </div>
          <div>
            <i class="iconfont" style="font-size: 23px; color: #b4bccc;">&#xe617;</i>
            <span>重叠预订</span>
          </div>
          <div>
            <i class="iconfont" style="font-size: 23px; color: #b4bccc;">&#xe631;</i>
            <span>脏房</span>
          </div>
        </div>
        <div style="display: flex; align-items: center;" class="room-icon-theme">
          <el-radio-group v-model="radio1" size="mini" @change="onChangeOverlap('远期',999)">
            <el-radio-button label="实时">
              <i class="iconfont">&#xe616;</i>
            </el-radio-button>
            <el-radio-button label="远期" icon="el-icon-edit">
              <i class="iconfont">&#xe638;</i>
            </el-radio-button>
          </el-radio-group>
          <i class="iconfont screen" :style="screen_roomName == '' ? 'cursor: pointer;font-size:20px;color: #999;padding-left: 30px;' : 'color: #f56c6c;cursor: pointer;font-size:20px;padding-left: 30px;'" @click="screen_display = true">&#xe63f;</i>
        </div>
      </div>

      <div v-else class="first_header2">
        <el-tabs v-if="shishitab" v-model="activeIndex" style="padding-right: 395px;" @tab-click="handleSelect">
          <el-tab-pane name="5">
            <span slot="label" :key="1" class="first_header2_icon">
              <p style="position: relative; bottom: 2px;">
                <i class="el-icon-menu" style="font-size: 20px;"></i>&nbsp;全部
              </p>
            </span>
          </el-tab-pane>
          <el-tab-pane name="4">
            <span slot="label" :key="2" class="first_header2_icon">
              <p>
                <i style=" width: 18px;height: 18px;background: linear-gradient(-30deg, rgba(53, 214, 138, 1),rgba(93, 226, 155, 1));margin-right: 5px;"></i>&nbsp;空闲（{{ count4 }}）
              </p>
            </span>
          </el-tab-pane>
          <el-tab-pane name="1">
            <span slot="label" class="first_header2_icon">
              <p style="width: 18px;height: 18px;background: linear-gradient(-30deg,rgba(255, 190, 53, 1),rgba(252, 225, 101, 1));margin-right: 5px;"></p>&nbsp;今日预到（{{ count1 }}）
            </span>
          </el-tab-pane>
          <el-tab-pane name="3">
            <span slot="label" class="first_header2_icon">
              <p style="width: 18px;height: 18px;background: linear-gradient(-30deg,rgba(75, 156, 254, 1),rgba(117, 180, 255, 1));margin-right: 5px;"></p>&nbsp;使用中（{{ count3 }}）
            </span>
          </el-tab-pane>
          <el-tab-pane name="8">
            <span slot="label" class="first_header2_icon">
              <p style="width: 18px;height: 18px;background: linear-gradient(-30deg,rgba(124,126,255,1),rgba(143,146,255,1));margin-right: 5px;"></p>&nbsp;使用超时（{{ count8 }}）
            </span>
          </el-tab-pane>
          <el-tab-pane name="6">
            <span slot="label" class="first_header2_icon">
              <img src="../../assets/images/lock.png" style="width: 20px; height: 20px;margin-right: 5px;" />&nbsp;锁位（{{ count6 }}）
              <!-- <p style="width: 18px;height: 18px;background: linear-gradient(-30deg,rgba(255, 93, 93, 1),rgba(255, 130, 130, 1));margin-right: 5px;"></p>&nbsp;锁位（{{ count6 }}） -->
            </span>
          </el-tab-pane>
          <el-tab-pane name="7">
            <span slot="label" :key="7" class="first_header2_icon">
              <img src="../../assets/images/dirty_room_1.png" style="width: 20px; height: 20px;margin-right: 5px;" />&nbsp;脏房（{{ count7 }}）
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="first_header2_right room-icon-theme">
          <el-radio-group v-model="radio1" size="mini" @change="onChangeOverlap('实时',999)">
            <el-radio-button label="实时">
              <i class="iconfont">&#xe616;</i>
            </el-radio-button>
            <el-radio-button label="远期" icon="el-icon-edit">
              <i class="iconfont">&#xe638;</i>
            </el-radio-button>
          </el-radio-group>
          <i class="iconfont screen" :style="(!screen_minute && screen_radio == '分' && !screen_roomName) ? 'cursor: pointer;font-size:20px;color: #999;padding-left: 30px;' : 'color: #f56c6c;cursor: pointer;font-size:20px;padding-left: 30px;'" @click="screen_display = true">&#xe63f;</i>
        </div>
      </div>
      <!-- 只有入住才有预离时间  tidyStatus 1为脏房 0为不是脏房 -->
      <div v-show="radio1 != '远期' && checkinRoomsList.length > 0" style="clear: both;padding-bottom: 60px;">
        <el-row v-if="titleStatus == 1">
          <el-col :span="24">
            <ul class="shishi_room_list">
              <el-popover v-for="(item, index) in checkinRoomsList" :key="index" :disabled="formDialogVisible || orderInfoDialog || lookBookDialog" placement="bottom" trigger="click">
                <div class="rbInfo">
                  <p class="rbTitle" :style="item.roomStatus == 3 || item.roomStatus == 7 ? 'line-height: 36px;' : ''">
                    {{ item.roomName }}
                    <span style="float: right;">
                      <el-button v-if="item.roomStatus == 2" class="ssbtn" size="medium" @click="lookBook(item,2)">查看预订</el-button>
                      <!-- <el-button v-if="item.orderId" size="medium" @click="roomSettlement(item)">查看订单</el-button> -->
                      <el-button v-if="item.roomStatus == 3 || item.roomStatus == 7" class="ssbtn" size="medium" @click="checkOrder(item.roomOrderId,item.orderId,item.isService,item.customerPhone,item.roomId,item.bedId)">查看订单</el-button>
                    </span>
                  </p>
                  <p v-if="item.roomStatus && item.roomStatus != 1" class="rbBorder">订单号：{{ item.orderCode || '--' }}</p>
                  <p v-if="item.roomStatus && item.roomStatus != 1" class="mt_10">顾客姓名：{{ item.customerName || '新增顾客' }}</p>
                  <p v-if="item.roomStatus && item.roomStatus != 1">手机号码：{{ item.customerPhone || '--' }}</p>
                  <p v-if="item.roomStatus && item.roomStatus != 1">{{ item.roomStatus == 2 ? '预' : '' }}使用时间：{{ item.beginTime || '--' }}</p>
                  <p v-if="item.roomStatus && item.roomStatus != 1">预离时间：{{ item.endTime || '--' }}</p>
                  <p v-if="item.roomStatus && item.roomStatus != 1 && item.roomStatus != 7">预计使用时长：{{ Lib.calculationTime(item.dateTime) }}</p>
                  <p v-if="item.roomStatus && item.roomStatus != 1 && item.roomStatus == 7">使用时长：{{ Lib.calculationTime(item.dateTime) }}（<span style="color: #F23030;"><positive-time :end-time="item.endTime"></positive-time></span>）</p>
                  <p v-if="item.roomStatus && item.roomStatus != 1">状态：<span :style="item.roomStatus == 2 ? 'color: #FF7316;' : item.roomStatus == 3 ? 'color: #FD5C8C;' : 'color: #8385FF;'">{{ item.roomStatus == 2 ? '今日预到' : item.roomStatus == 3 ? '使用中' : '使用超时' }}</span></p>
                  <p v-if="item.roomStatus && item.roomStatus != 1" :class="item.roomStatus != 3 && item.roomStatus != 7 ? 'rbBorder' : ''">备注：{{ item.remarks || '--' }}</p>
                  <div class="rbBtn">
                    <el-button v-if="item.tidyStatus == 1" class="ssbtn" size="medium" @click="onCleanRoomFun(undefined, item.roomId)">置净</el-button>
                    <el-button v-else class="ssbtn" size="medium" @click="onSetDirtyRoom(undefined, item.roomId)">置脏</el-button>
                    <el-button v-if="!item.roomStatus || item.roomStatus === 6 || item.roomStatus === 8" class="ssbtn" size="medium" @click="onLockupRoomFun(undefined,undefined,item.roomId,item.bedId)">锁房</el-button>
                    <el-button v-if="item.roomStatus === 1" class="ssbtn" size="medium" @click="onUnlockRoom(undefined,undefined,item.roomOrderId)">解锁</el-button>
                  </div>
                </div>
                <li slot="reference" class="shishi_room_list_item" :style="returnShiShi(item)" @mouseenter="chooseBed(item.roomId)" @mouseleave="chooseBed('')" @click="chooseBedLi = index">
                  <div v-show="chooseBedLi == index" class="ssbedChoose">
                    <el-button v-if="item.roomStatus != 1 && item.roomStatus != 3 && item.roomStatus != 7" class="ssbtn" size="medium" @click="onBookingOrCheckIn('新增预订',item.roomId, item.bedId, item)">新增预订</el-button>
                    <el-button v-if="(!item.roomStatus || item.roomStatus == 2 || item.roomStatus == 6) && item.roomStatus != 3" class="ssbtn" size="medium" @click="onBookingOrCheckIn('新增使用',item.roomId, item.bedId, item)">新增使用</el-button>
                  </div>
                  <p>{{ item.roomName }}</p>
                  <p>{{ (!item.roomStatus || item.roomStatus == 1) ? '' : (item.customerName || '新增顾客') }}</p>
                  <p>
                    <positive-time v-if="item.roomStatus == 7" :end-time="item.endTime || item.createTime"></positive-time>
                    <count-down v-if="item.roomStatus == 2 || item.roomStatus == 3" :id="index+''" :start-time="item.startTimeStamp" :end-time="item.endTimeStamp" :day-txt="'天'" :seconds-txt="item.roomStatus == 2 ? '到' : '离'" class="timer"></count-down>
                  </p>
                  <div class="shishi_room_button_list">
                    <div class="shishi_room_button_left_list">
                      <img v-if="item.tidyStatus === 1" src="../../assets/images/dirty_room_1.png" />
                      <img v-if="(item.tidyStatus === 0 && !item.roomStatus) || (item.tidyStatus === 0 && item.roomStatus === 6)" src="../../assets/images/dirty_room_5.png" />
                      <img v-if="item.tidyStatus === 0 && item.roomStatus === 3" src="../../assets/images/dirty_room_2.png" />
                      <img v-if="item.tidyStatus === 0 && item.roomStatus === 2" src="../../assets/images/dirty_room_3.png" />
                      <img v-if="item.tidyStatus === 0 && item.roomStatus === 1" src="../../assets/images/dirty_room_4.png" />
                      <img v-if="item.tidyStatus === 0 && item.roomStatus === 7" src="../../assets/images/dirty_room_7.png" />
                      <img v-if="item.roomStatus == 1 && item.roomStatus === 1" style="margin-left: 10px" src="../../assets/images/roomLock.png" />
                    </div>
                  </div>
                </li>
              </el-popover>
            </ul>
          </el-col>
        </el-row>
        <div v-else class="bedList">
          <ul v-if="bedInfo.cardNumber > 0">
            <el-popover v-for="(v, n) in checkinRoomsList" :key="n" :disabled="formDialogVisible || orderInfoDialog || lookBookDialog" placement="bottom" trigger="click">
              <div class="rbInfo">
                <p class="rbTitle" :style="v.roomStatus == 3 || v.roomStatus == 7 ? 'line-height: 36px;' : ''">
                  {{ v.roomName }}/{{ v.bedNumber }}
                  <span style="float: right;">
                    <el-button v-if="v.roomStatus == 2" class="ssbtn" size="medium" @click="lookBook(v,2)">查看预订</el-button>
                    <!-- <el-button v-if="v.orderId" size="medium" @click="roomSettlement(v)">查看订单</el-button> -->
                    <el-button v-if="v.roomStatus == 3 || v.roomStatus == 7" class="ssbtn" size="medium" @click="checkOrder(v.roomOrderId,v.orderId,v.isService,v.customerPhone,v.roomId,v.bedId)">查看订单</el-button>
                  </span>
                </p>
                <p v-if="v.roomStatus && v.roomStatus != 1" class="rbBorder">订单号：{{ v.orderCode || '--' }}</p>
                <p v-if="v.roomStatus && v.roomStatus != 1" class="mt_10">顾客姓名：{{ v.customerName || '新增顾客' }}</p>
                <p v-if="v.roomStatus && v.roomStatus != 1">手机号码：{{ v.customerPhone || '--' }}</p>
                <p v-if="v.roomStatus && v.roomStatus != 1">{{ v.roomStatus == 2 ? '预' : '' }}使用时间：{{ v.beginTime || '--' }}</p>
                <p v-if="v.roomStatus && v.roomStatus != 1">预离时间：{{ v.endTime || '--' }}</p>
                <p v-if="v.roomStatus && v.roomStatus != 1 && v.roomStatus != 7">预计使用时长：{{ Lib.calculationTime(v.dateTime) }}</p>
                <p v-if="v.roomStatus && v.roomStatus != 1 && v.roomStatus == 7">使用时长：{{ Lib.calculationTime(v.dateTime) }}（<span style="color: #F23030;"><positive-time :end-time="v.endTime"></positive-time></span>）</p>
                <p v-if="v.roomStatus && v.roomStatus != 1">状态：<span :style="v.roomStatus == 2 ? 'color: #FF7316;' : v.roomStatus == 3 ? 'color: #FD5C8C;' : 'color: #8385FF;'">{{ v.roomStatus == 2 ? '今日预到' : v.roomStatus == 3 ? '使用中' : '使用超时' }}</span></p>
                <p v-if="v.roomStatus && v.roomStatus != 1" :class="v.roomStatus != 3 && v.roomStatus != 7 ? 'rbBorder' : ''">备注：{{ v.remarks || '--' }}</p>
                <div class="rbBtn">
                  <el-button v-if="v.tidyStatus == 1" class="ssbtn" size="medium" @click="onCleanRoomFun(undefined, v.bedId)">置净</el-button>
                  <el-button v-else class="ssbtn" size="medium" @click="onSetDirtyRoom(undefined, v.bedId)">置脏</el-button>
                  <el-button v-if="!v.roomStatus" class="ssbtn" size="medium" @click="onLockupRoomFun(undefined,undefined,v.roomId,v.bedId)">锁房</el-button>
                  <el-button v-if="v.roomStatus == 1" class="ssbtn" size="medium" @click="onUnlockRoom(undefined,undefined,v.roomOrderId)">解锁</el-button>
                </div>
              </div>
              <li slot="reference" class="shishi_room_list_item" :style="returnShiShi(v)" :class="v.roomId == chooseRoomId ? 'fangda' : ''" @mouseenter="chooseBed(v.roomId)" @mouseleave="chooseBed('')" @click="v.roomStatus == 2 ? '' : (chooseBedLi = n)">
                <div v-if="chooseBedLi == n" class="ssbedChoose">
                  <el-button v-if="v.roomStatus != 1 && v.roomStatus != 3 && v.roomStatus != 7" class="ssbtn" size="medium" @click="onBookingOrCheckIn('新增预订',v.roomId, v.bedId, v)">新增预订</el-button>
                  <el-button v-if="(!v.roomStatus || v.roomStatus == 2 || v.roomStatus == 6) && v.roomStatus != 3" class="ssbtn" size="medium" @click="onBookingOrCheckIn('新增使用',v.roomId, v.bedId, v)">新增使用</el-button>
                </div>
                <h1>{{ v.bedNumber }}</h1>
                <h2>{{ v.roomName }}</h2>
                <h4 v-if="v.customerName && v.roomStatus != 1">{{ v.customerName }}</h4>
                <h3 :style="v.customerName && v.roomStatus != 1 ? '' : 'padding-top: 50px;'">
                  <positive-time v-if="v.roomStatus == 7" :end-time="v.endTime"></positive-time>
                  <count-down v-if="v.roomStatus == 2 || v.roomStatus == 3" :id="n+''" :start-time="v.startTimeStamp" :end-time="v.endTimeStamp" :day-txt="'天'" :seconds-txt="v.roomStatus == 2 ? '到' : '离'" class="timer"></count-down>
                  <i v-if="v.tidyStatus == 1" class="iconfont">&#xe631;</i>
                  <i v-if="v.roomStatus == 1" style="margin-left: 0;" class="iconfont el-icon-lock"></i>
                </h3>
              </li>
            </el-popover>
          </ul>
          <p v-else>暂无{{ Lib.returnRoomOrBed() }}数据</p>
        </div>
      </div>

      <gt-noneData v-show="radio1 != '远期' && checkinRoomsList.length == 0" :title="'暂无房间数据'"></gt-noneData>

      <el-table v-show="first_loading && radio1 === '远期' && roomListData.length > 0" ref="main_table" tooltip-effect="light" :data="roomListData" size="medium" style="width: 100%;margin-bottom: 60px;" border :max-height="max_height" :row-style="{ height: '100px' }" :cell-style="cellStyle" :header-cell-style="headerStyle" :header-cell-class-name="headerClass" :cell-class-name="cellClass" @cell-mouse-leave="clickCell" @cell-mouse-enter="clickCell" @cell-click="clickCellEvent">
        <el-table-column v-if="titleStatus == 1" width="275" align="center" :lable="'选择时间'" fixed>
          <template slot="header" slot-scope="scope">
            <div v-show="scope" style="cursor: pointer;">
              <p @click="showDatePicker($event)">《 {{ date_range[0] }} 至 {{ date_range[1] }} 》</p>
              <el-date-picker ref="saveDateInput" v-model="date_range" type="daterange" value-format="yyyy-MM-dd" style=" display: inline-block; visibility: hidden;position: absolute;top: 0;bottom: 0;left: 95px;right: 0;z-index: 99999;" :editable="false" :clearable="false" @change="onDateChange" />
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.roomName }}
            <p class="future_booking" style="bottom: 17px;">未来预订人数：{{ scope.row.bookPepNum || 0 }}</p>
            <p v-if="scope.row.tidyStatus == 1" class="futureIcon"><i class="iconfont">&#xe631;</i></p>
          </template>
        </el-table-column>
        <el-table-column v-else width="275" align="center" :lable="'选择时间'" fixed>
          <template slot="header" slot-scope="scope">
            <div v-show="scope" style="cursor: pointer;">
              <p @click="showDatePicker($event)">《 {{ date_range[0] }} 至 {{ date_range[1] }} 》</p>
              <el-date-picker ref="saveDateInput" v-model="date_range" type="daterange" value-format="yyyy-MM-dd" style=" display: inline-block; visibility: hidden;position: absolute;top: 0;bottom: 0;left: 95px;right: 0;z-index: 99999;" :editable="false" :clearable="false" @change="onDateChange" />
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.roomOrBed == 1 ? scope.row.roomName : scope.row.bedNumber }}
            <p v-if="scope.row.roomName" class="future_booking" style="bottom: 17px;">未来预订人数：{{ scope.row.bookPepNum || 0 }}</p>
            <p v-if="scope.row.bedType == 1" class="futureIcon"><i class="iconfont">&#xe631;</i></p>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, i) in date_table_column" :key="i" :min-width="column_min_width" header-align="center" :render-header="renderheader" :label="item.date +' 周' +item.day +( ' 预订' +returnNewLeftRoomNum(item.date, i)+'人')" align="center">
          <template slot-scope="scope">
            <div v-if="titleStatus == 1" class="roomTd">{{ returnRoomerName(scope, item.date, 1) }}</div>
            <div v-if="titleStatus == 1" class="roomTd">{{ returnRoomerName(scope, item.date, 2) }}</div>
            <div v-if="titleStatus != 1 && scope.row.roomOrBed == 1" class="roomTd">{{ returnBedName(scope, item.date, 0) }}</div>
            <div v-if="titleStatus != 1 && scope.row.roomOrBed == 2" class="roomTd">{{ returnBedName(scope, item.date, 1) }}</div>
            <div v-if="titleStatus != 1 && scope.row.roomOrBed == 2" class="roomTd">{{ returnBedName(scope, item.date, 2) }}</div>
            <i v-if="returnClock(scope,item.date)" class="iconfont time_clock">&#xe621;</i>
            <i v-if="returnOverlap(scope, item.date)" class="iconfont person_clock">&#xe617;</i>
            <i v-if="returnLockRoom(scope, item.date)" class="iconfont time_clock el-icon-lock"></i>
          </template>
        </el-table-column>
      </el-table>
      <gt-noneData v-show="first_loading && radio1 === '远期' && roomListData.length == 0" :title="'暂无房间数据'"></gt-noneData>

      <ul v-if="showDropdown_vis" class="dropdown_dif" :style="{ top: dropdown_y, left: dropdown_x }">
        <li v-if="table_add == 2 && dropdown_num == 0" @click="handleCommand('x', dropdown_row, dropdown_col)">新增预订</li>
        <li v-if="table_add == 2 && dropdown_num == 0" @click="handleCommand('y', dropdown_row, dropdown_col)">使用</li>
        <li v-if="table_button_status == 99 && (!dropdown_col.label && titleStatus == 1 ? false : true) && (dropdown_type != 1 || table_button_status == 11)" @click="handleCommand('x', dropdown_row, dropdown_col)">新增预订</li>
        <li v-if="table_button_status == 99 && (!dropdown_col.label && titleStatus == 1 ? false : true) && (dropdown_type != 1 || table_button_status == 11)" @click="handleCommand('y', dropdown_row, dropdown_col)">使用</li>
        <li v-if="!dropdown_col.label && titleStatus == 1" @click="handleCommand('r', dropdown_row, dropdown_col)">房间记录</li>
        <li v-if="!dropdown_col.label && titleStatus != 1 && dropdown_row.roomOrBed == 1 && dropdown_num != 0" @click="handleCommand('r', dropdown_row, dropdown_col)">房间记录</li>
        <li v-if="!dropdown_col.label && dropdown_row.tidyStatus == 0 && titleStatus == 1" @click="handleCommand('d', dropdown_row, dropdown_col)">置脏</li>
        <li v-if="!dropdown_col.label && dropdown_row.tidyStatus == 1 && titleStatus == 1" @click="handleCommand('e', dropdown_row, dropdown_col)">置净</li>
        <li v-if="!dropdown_col.label && dropdown_row.bedType == 0 && titleStatus != 1" @click="handleCommand('d', dropdown_row, dropdown_col)">置脏</li>
        <li v-if="!dropdown_col.label && dropdown_row.bedType == 1 && titleStatus != 1" @click="handleCommand('e', dropdown_row, dropdown_col)">置净</li>
        <li v-if="table_button_status === 1 || table_button_status === 2 || table_button_status === 3" @click="handleCommand('p', dropdown_row, dropdown_col)">房间详情</li>
        <li v-if="table_button_status === 11 && dropdown_col.label && dropdown_num != 0" @click="handleCommand('p', dropdown_row, dropdown_col)">房间详情</li>
        <li v-if="table_button_status === 22 && dropdown_col.label && dropdown_num != 0" @click="handleCommand('b', dropdown_row, dropdown_col)">{{ Lib.returnRoomOrBed() }}详情</li>
        <li v-if="(!dropdown_type || dropdown_type == 5 || dropdown_type == 8) && lockRoomStatus == 1 && table_button_status !== 11" @click="handleCommand('s', dropdown_row, dropdown_col)">锁房</li>
        <li v-if="dropdown_type == 1 && table_button_status !== 11" @click="handleCommand('j', dropdown_row, dropdown_col)">解锁</li>
        <li v-if="dropdown_num != 0 || table_button_status !== 11" @click="showDropdown_vis = false">取消</li>
      </ul>

      <el-dialog :title="formTitle" :visible.sync="formDialogVisible" width="550px" append-to-body :show-close="true" :before-close="onCloseFormDialog" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="form" :rules="rules" :model="form" label-width="120px">
          <el-form-item v-if="!(formTitle === '修改' && form.name === '')" label="姓名：" prop="name" :rules="[{required: true,message: '请输入姓名',trigger: 'blur'},{required: true,message: '请输入姓名',trigger: 'change'},{min: 1,max: 15,message: '长度在 1 到 15 个字符',trigger: 'blur'}]">
            <el-input ref="search_input2" v-model="form.name" style="width: 240px;" placeholder="请输入姓名" :maxlength="15" :disabled="((fix_infoType === 2 || fix_infoType === 3 || fix_infoType === 7) && formTitle != '新增预订' && formTitle != '新增使用') || nameStatus == 2">
            </el-input>
            <i class="iconfont phone_book new_phone_style" :style="((fix_infoType === 2 || fix_infoType === 3 || fix_infoType === 7) && formTitle != '新增预订' && formTitle != '新增使用') ? 'cursor: not-allowed;' : ''" @click="((fix_infoType === 2 || fix_infoType === 3 || fix_infoType === 7) && formTitle != '新增预订' && formTitle != '新增使用') ? '' : onShowPhoneBook()">&#xe646;</i>
          </el-form-item>
          <el-form-item v-if="!(formTitle === '修改' && form.name === '')" label="手机号码：" prop="phone">
            <el-input id="disableInput" ref="search_input3" v-model.number="form.phone" style="width: 240px;" placeholder="请输入手机号码" maxlength="11" :disabled="(fix_infoType === 2 || fix_infoType === 3 || fix_infoType === 7) && formTitle != '新增预订' && formTitle != '新增使用'" @keyup.enter.native="test3(3)" @input="changePhone" />
          </el-form-item>
          <div :class="starPhoneVal ? 'starPhoneClass' : ''">{{ starPhoneVal }}</div>
          <div v-if="starPhoneVal &&(formTitle === '修改' || formTitle === '确认使用')" class="starPhoneDisabled">
            <span>{{ form.phone.substring(0,3) }}</span>
            <samp>****</samp>
            <span>{{ form.phone.substring(7,11) }}</span>
          </div>
          <el-form-item v-if="formTitle === '新增使用' || formTitle === '确认使用'" label="使用时间：" :rules="{required: true,message: '请输入使用时间',trigger: 'blur',}">
            <span>{{ form.now }}</span>
          </el-form-item>
          <el-form-item v-if="formTitle === '新增预订' || formTitle === '修改'" label="预使用时间：" :rules="{required: true,message: '请输入使用时间',trigger: 'blur',}">
            <el-date-picker v-model="form.now" type="datetime" placeholder="选择时间" :clearable="false" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :picker-options="{
              disabledDate:disabledDate,
              selectableRange:selectableRange
            }" @focus="pickerChange"
            />
          </el-form-item>
          <el-form-item label="预离时间：" prop="endTime" :rules="{required: true,message: '请输入预离时间',trigger: 'blur'}">
            <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择时间" :clearable="false" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :picker-options="{disabledDate:disabledLeaveDate,selectableRange:selectableLeaveRange}" @change="editLeaveDate" />
            <span>&nbsp;{{ onGetLastedTime(form.endTime) }}</span>
          </el-form-item>
          <el-form-item v-if="titleStatus != 1" label="使用人数：" :rules="{required: true}">
            <span>{{ form.chooseRoom ? form.chooseRoom.length : 0 }}</span>
            <span>&nbsp;&nbsp;人</span>
          </el-form-item>
          <el-form-item v-if="titleStatus == 1" :label="'选择'+Lib.returnRoomOrBed()+'：'" :rules="[{required: true,message: '请选择'+Lib.returnRoomOrBed(),trigger: 'change',},{required: true,message: '请选择'+Lib.returnRoomOrBed(),trigger: 'blur',}]">
            <el-select v-model="chooseRoomList" placeholder="请选择房间" :disabled="!(form.now && form.endTime)" style="width:273px" multiple @focus="onGetUsableRoom(form.now,form.endTime)" @change="roomInfoChange">
              <el-option v-for="(a, i) in room_List" :key="i" :label="a.name" :value="a.id" :disabled="a.lastRoomNum == 0 || a.disabled">
                <span style="float: left;">{{ a.name }}</span>
                <span style="float: right;color: #fd5c8c;font-size: 13px;">{{ a.roomStatus == 1 ? '已锁定' : a.roomStatus == 2 ? '已预订' : a.roomStatus == 3 ? '已入住' : a.roomStatus == 5 ? '已退房' : a.roomStatus == 6 ? '已过期' : a.roomStatus == 7 ? '已超时' : '' }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else :label="'选择'+Lib.returnRoomOrBed()+'：'" prop="chooseRoom">
            <el-cascader v-model="form.chooseRoom" :disabled="!(form.now && form.endTime)" :options="roomOptions" :props="roomProps" clearable :placeholder="'请选择'+Lib.returnRoomOrBed()" @change="chooseCascader">
              <template slot-scope="{ node, data }">
                <span>{{ data.name }}</span>
                <span v-if="!node.isLeaf" class="themeFC" style="float: right;padding-left: 20px;"> (剩余{{ data.lastRoomNum }}) </span>
                <span v-else style="float: right;padding-left: 20px;color: #C0C4CC;">{{ data.bedStatus == 1 ? '已锁定' : data.bedStatus == 2 ? '已预订' : data.bedStatus == 3 ? '已入住' : data.bedStatus == 5 ? (titleStatus == 1 ? '已退房' : '已退位') : data.bedStatus == 6 ? '已过期' : data.bedStatus == 7 ? '已超时' : '' }}</span>
              </template>
            </el-cascader>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="form.desc" type="textarea" placeholder="请输入内容" :maxlength="20" :autosize="{ minRows: 2, maxRows: 4 }" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <label class="colleagues" :class="titleStatus == 1 ? form.domains.length > 0 ? 'themeFC' : '' : form.chooseRoom ? form.chooseRoom.length > 0 ? 'themeFC' : '' : ''" @click="titleStatus == 1 ? form.domains.length > 0 ? addColleagues() : '' : form.chooseRoom ? form.chooseRoom.length > 0 ? addColleagues() : '' : ''"><i class="iconfont" :class="titleStatus == 1 ? form.domains.length > 0 ? 'themeFC' : '' : form.chooseRoom ? form.chooseRoom.length > 0 ? 'themeFC' : '' : ''">&#xe635;</i>同行人</label>
          <el-button @click="onCloseFormDialog">取 消</el-button>
          <el-button type="primary" :disabled="(form.name && form.endTime && form.domains.length > 0) ? false : true" @click="formTitle === '修改'? onChangeRoom(): formTitle === '新增预订'? onConfirmFormDialog(): formTitle === '确认使用'? onConfirmCheckIn(): onFormToCheckIn()">确 定</el-button>
          <el-button v-if="formTitle === '新增使用' || formTitle === '确认使用'" type="primary" :disabled="(form.name && form.endTime && form.domains.length > 0) ? false : true" @click="onConfirmOrder()">确定并开单</el-button>
        </span>
      </el-dialog>

      <!-- 房间详情专用 -->
      <el-dialog :title="'房间详情-'+room_title" :visible.sync="detailDialogVisible" :width="detail_dialog_width" append-to-body>
        <el-input v-if="titleStatus != 1" v-model="roomDetailsSearch" style="width: 240px;" placeholder="顾客姓名/手机号码" @change="roomDetailsSwitchPageNum(1)">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-if="titleStatus != 1" v-model="roomDetailsStatus" class="ml_20" @change="roomDetailsSwitchPageNum(1)">
          <el-option label="全部" value=""></el-option>
          <el-option label="已使用" value="3"></el-option>
          <el-option label="已超时" value="7"></el-option>
          <el-option label="已预订" value="2"></el-option>
          <el-option label="已过期" value="6"></el-option>
          <el-option label="已退位" value="5"></el-option>
          <el-option label="已取消" value="8"></el-option>
        </el-select>
        <el-select v-if="titleStatus != 1" v-model="roomDetailsBedNum" class="ml_20" @change="roomDetailsSwitchPageNum(1)">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(v,n) in roomBedList" :key="n" :label="v.bedNumber" :value="v.id"></el-option>
        </el-select>
        <span v-if="titleStatus != 1" class="diaFrinfo">{{ handleBedDate }}</span>
        <el-table tooltip-effect="light" :data="detail_table_list" :style="titleStatus != 1 ? 'width: 100%;margin-top: 20px;' : 'width: 100%;'" @sort-change="roomDetailsSortChange">
          <el-table-column type="expand">
            <template slot-scope="props">
              <p style="height: 12px;line-height: 12px;">
                <span style="margin-left: 10px;">手机号码：{{ props.row.customerPhone ? Lib.starPhone(props.row.customerPhone) : '--' }}</span>
                <span v-if="props.row.createTime" style="margin-left: 10px;">预订时间：{{ props.row.createTime }}</span>
                <span v-if="props.row.remarks" style="margin-left: 10px;">备注：{{ props.row.remarks }}</span>
              </p>
              <div v-if="props.row.dtoList.length > 0">
                <p style="margin: 20px 0 0 10px;">同行人信息</p>
                <p v-for="(v,n) in props.row.dtoList" :key="n">
                  <span style="margin-left: 10px;">顾客姓名：{{ v.customerName || '--' }}</span>
                  <span style="margin-left: 10px;">手机号码：{{ v.phone || '--' }}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="customerName" label="姓名" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.customerName?scope.row.customerName:'新增顾客' }}
            </template>
          </el-table-column>
          <el-table-column prop="orderStatus" label="状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.orderStatus == 2">已预订</span>
              <span v-else-if="scope.row.orderStatus == 3">已使用</span>
              <span v-else-if="scope.row.orderStatus == 5">已退位</span>
              <span v-else-if="scope.row.orderStatus == 6">已过期</span>
              <span v-else-if="scope.row.orderStatus == 7">已超时</span>
              <span v-else>已取消</span>
            </template>
          </el-table-column>
          <el-table-column prop="beginTime" width="170" show-overflow-tooltip label="使用时间" sortable="custom">
            <template slot-scope="scope">
              <span :style="scope.row.overBookTime*1 > 0 ? 'color: #F56C6C;' : ''">{{ scope.row.beginTime || '--' }}</span>
              <el-tooltip v-if="scope.row.overBookTime*1 > 0" placement="bottom" effect="light">
                <div slot="content">已超使用时间{{ Lib.calculationTime(scope.row.overBookTime) }}</div>
                <i class="iconfont" style="color: #F56C6C;font-size: 20px;padding-left: 5px;">&#xe709;</i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" width="170" label="离店时间" show-overflow-tooltip sortable="custom">
            <template slot-scope="scope">
              <span :style="scope.row.overTime*1 > 0 ? 'color: #F56C6C;' : ''">{{ scope.row.endTime || '--' }}</span>
              <el-tooltip v-if="scope.row.overTime*1 > 0" placement="bottom" effect="light">
                <div slot="content">已超使用时间{{ Lib.calculationTime(scope.row.overTime) }}</div>
                <i class="iconfont" style="color: #F56C6C;font-size: 20px;padding-left: 5px;">&#xe709;</i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="dateTime" label="使用时长" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ Lib.calculationTime(scope.row.dateTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button v-if="scope.row.orderStatus == 3 || scope.row.orderStatus == 5 || scope.row.orderStatus == 7" type="text" @click="checkOrder(scope.row.roomOrderId,scope.row.customerOrderId,scope.row.isService,scope.row.customerPhone,scope.row.roomId,scope.row.bedId)">查看订单</el-button>
              <el-button v-else type="text" @click="lookBook(scope.row)">查看预订</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-pagination background :current-page.sync="roomDetailsPageNum" :page-size="10" layout="prev, pager, next, jumper" :total="roomDetailsRowCount" @size-change="roomDetailsSwitchPageNum" @current-change="roomDetailsSwitchPageNum">
          </el-pagination>
        </div>
      </el-dialog>
      <!-- 床位详情专用 -->
      <el-dialog :title="Lib.returnRoomOrBed()+'详情-'+room_title+'/'+bed_title" :visible.sync="bedDialogVisible" :width="detail_dialog_width" append-to-body>
        <el-input v-model="bedSearch" style="width: 240px;" placeholder="顾客姓名/手机号码" @change="onGetDateBedDetails">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-model="bedVal" class="ml_20" @change="onGetDateBedDetails">
          <el-option label="全部" value=""></el-option>
          <el-option label="已使用" value="3"></el-option>
          <el-option label="已超时" value="7"></el-option>
          <el-option label="已预订" value="2"></el-option>
          <el-option label="已过期" value="6"></el-option>
          <el-option label="已退位" value="5"></el-option>
          <el-option label="已取消" value="8"></el-option>
        </el-select>
        <span class="diaFrinfo">{{ handleBedDate }}</span>
        <el-table tooltip-effect="light" :data="detail_table_list" style="width: 100%;margin-top: 20px;" @sort-change="bedDetailsSortChange">
          <el-table-column type="expand">
            <template slot-scope="props">
              <p style="height: 12px;line-height: 12px;">
                <span style="margin-left: 10px;">手机号码：{{ props.row.customerPhone ? Lib.starPhone(props.row.customerPhone) : '--' }}</span>
                <span v-if="props.row.createTime" style="margin-left: 10px;">预订时间：{{ props.row.createTime }}</span>
                <span v-if="props.row.remarks" style="margin-left: 10px;">备注：{{ props.row.remarks }}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="customerName" label="姓名" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.customerName?scope.row.customerName:'新增顾客' }}
            </template>
          </el-table-column>
          <el-table-column prop="orderStatus" label="状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.orderStatus == 2">已预订</span>
              <span v-else-if="scope.row.orderStatus == 3">已使用</span>
              <span v-else-if="scope.row.orderStatus == 5">已退位</span>
              <span v-else-if="scope.row.orderStatus == 6">已过期</span>
              <span v-else-if="scope.row.orderStatus == 7">已超时</span>
              <span v-else>已取消</span>
            </template>
          </el-table-column>
          <el-table-column prop="beginTime" width="170" show-overflow-tooltip label="使用时间" sortable="custom">
            <template slot-scope="scope">
              <span :style="scope.row.overBookTime*1 > 0 ? 'color: #F56C6C;' : ''">{{ scope.row.beginTime || '--' }}</span>
              <el-tooltip v-if="scope.row.overBookTime*1 > 0" placement="bottom" effect="light">
                <div slot="content">已超使用时间{{ Lib.calculationTime(scope.row.overBookTime) }}</div>
                <i class="iconfont" style="color: #F56C6C;font-size: 20px;padding-left: 5px;">&#xe709;</i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" width="170" label="离店时间" show-overflow-tooltip sortable="custom">
            <template slot-scope="scope">
              <span :style="scope.row.overTime*1 > 0 ? 'color: #F56C6C;' : ''">{{ scope.row.endTime || '--' }}</span>
              <el-tooltip v-if="scope.row.overTime*1 > 0" placement="bottom" effect="light">
                <div slot="content">已超使用时间{{ Lib.calculationTime(scope.row.overTime) }}</div>
                <i class="iconfont" style="color: #F56C6C;font-size: 20px;padding-left: 5px;">&#xe709;</i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="dateTime" label="使用时长" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ Lib.calculationTime(scope.row.dateTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button v-if="scope.row.orderStatus == 3 || scope.row.orderStatus == 5 || scope.row.orderStatus == 7" type="text" @click="checkOrder(scope.row.roomOrderId,scope.row.customerOrderId,scope.row.isService,scope.row.customerPhone,scope.row.roomId,scope.row.bedId)">查看订单</el-button>
              <el-button v-else type="text" @click="lookBook(scope.row)">查看预订</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-pagination background :current-page.sync="bedPageNum" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="switchPageNum" @current-change="switchPageNum">
          </el-pagination>
        </div>
      </el-dialog>

      <book :show.sync="bookVisible"></book>
      <drawer :title="Lib.returnRoomOrBed()+'筛选'" :display.sync="screen_display">
        <div class="li">
          <p>快速查找：</p>
          <el-input v-model="screen_roomName" :placeholder="'输入'+Lib.returnRoomOrBed()+'名称搜索'" @focus="showDropdown_vis = false" @keyup.enter.native="screenInputSearch">
            <i slot="suffix" style="cursor: pointer" class="el-input__icon el-icon-search" @click="screenInputSearch"></i>
          </el-input>
        </div>
        <div v-if="radio1 === '实时'" class="li">
          <p>预离时间间隔：</p>
          <el-row type="flex" justify="space-between">
            <el-input-number v-model="screen_minute" :min="0" :max="screen_radio == '分' ? 108000 : screen_radio == '时' ? 1800 : 30" :step-strictly="true" @keyup.enter.native="screenInputSearch"></el-input-number>
            <el-radio-group v-model="screen_radio">
              <el-radio-button label="分" />
              <el-radio-button label="时" />
              <el-radio-button label="天" />
            </el-radio-group>
          </el-row>
        </div>
        <div class="dfoot" @click="resetStatus == true ? '' : resetScreen()">重置</div>
      </drawer>

      <el-dialog title="添加同行人" class="deduction" :visible.sync="colleaguesDia" width="680px" append-to-body>
        <el-table tooltip-effect="light" :data="newColleaguesData" row-key="id" :expand-row-keys="openListKey" max-height="600">
          <el-table-column prop="roomName" label="房间名称" :width="titleStatus == 1 ? 220 : 190" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <i v-show="scope.$index == 0" style="font-size: 18px;color: #D2D2D2;padding-right: 5px;" class="iconfont">&#xea44;</i>{{ scope.row.roomName }}
            </template>
          </el-table-column>
          <el-table-column v-if="titleStatus != 1" width="70" prop="bedNum" :label="Lib.returnRoomOrBed()" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="顾客姓名" width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name" :disabled="scope.$index == 0 ? true : false" size="mini" style="width: 150px;" :maxlength="15"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="电话号码" :width="titleStatus == 1 ? '210' : '180'">
            <template slot-scope="scope">
              <el-input v-model="scope.row.phone" :disabled="scope.$index == 0 ? true : false" size="mini" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{})[\d+\.]/g, '')" style="width: 150px;" :maxlength="11" @change="checkPhone(scope.row.phone,scope.$index,1)"></el-input>
              <i v-if="titleStatus == 1" class="iconfont el-icon-circle-plus themeFC" style="font-size: 26px;position: relative;top: 4px;margin-left: 10px;cursor: pointer;" @click="addAndSubMember(1,scope.$index)"></i>
            </template>
          </el-table-column>
          <el-table-column v-if="titleStatus == 1" type="expand" width="10">
            <template slot-scope="scope">
              <div class="tableExpandList">
                <div v-for="(v,n) in scope.row.chooseList" :key="n" class="li">
                  <el-input v-model="v.name" size="mini" class="tinputOne" :maxlength="15"></el-input>
                  <el-input v-model="v.phone" size="mini" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{})[\d+\.]/g, '')" class="tinputTwo" :maxlength="11" @change="checkPhone(v.phone,scope.$index,2,n)"></el-input>
                  <i class="iconfont el-icon-remove" @click="addAndSubMember(2,scope.$index,n)"></i>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <label class="colleagues">不填写同行人信息时，房态顾客信息将直接使用开单人信息</label>
          <el-button @click="confirmCancel">取 消</el-button>
          <el-button type="primary" @click="confirmAdd">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="今日预到" :visible.sync="todayDialog" width="1000px" append-to-body>
        <el-input v-model="todaySearch" style="width: 240px;" placeholder="顾客姓名/手机号码" @change="getTodayListData">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-if="titleStatus == 1" v-model="todayRoomVal" class="ml_20" @change="getTodayListData">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(v,n) in todayRoomList" :key="n" :label="v.name" :value="v.id"></el-option>
        </el-select>
        <el-select v-model="todayTime" class="ml_20" @change="getTodayListData">
          <el-option label="全部" value=""></el-option>
          <el-option label="15min内预到" :value="15"></el-option>
          <el-option label="30min内预到" :value="30"></el-option>
          <el-option label="45min内预到" :value="45"></el-option>
          <el-option label="60min内预到" :value="60"></el-option>
          <el-option label="90min内预到" :value="90"></el-option>
          <el-option label="120min内预到" :value="120"></el-option>
        </el-select>
        <el-cascader v-if="titleStatus != 1" v-model="todayBedVal" class="ml_20" :options="todayBedList" :props="todayBedProps" clearable collapse-tags @change="getTodayListData">
          <template slot-scope="{ data }">
            <span>{{ data.name }}</span>
          </template>
        </el-cascader>
        <p v-if="todayNumber" class="diaFrinfo">有 <span class="themeColor">{{ todayNumber }}</span> 条预订信息超过使用时间</p>
        <el-table tooltip-effect="light" :data="todayList" style="width: 100%;margin-top: 20px;" @sort-change="todaySortChange">
          <el-table-column type="expand">
            <template slot-scope="props">
              <p style="height: 12px;line-height: 12px;">
                <span style="margin-left: 10px;">手机号码：{{ props.row.customerPhone ? Lib.starPhone(props.row.customerPhone) : '--' }}</span>
                <span v-if="props.row.createTime" style="margin-left: 10px;">预订时间：{{ props.row.createTime }}</span>
                <span v-if="props.row.remarks" style="margin-left: 10px;">备注：{{ props.row.remarks }}</span>
              </p>
              <div v-if="props.row.dtoList.length > 0">
                <p style="margin: 20px 0 0 10px;">同行人信息</p>
                <p v-for="(v,n) in props.row.dtoList" :key="n">
                  <span style="margin-left: 10px;">顾客姓名：{{ v.customerName || '--' }}</span>
                  <span style="margin-left: 10px;">手机号码：{{ v.phone || '--' }}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="customerName" label="姓名" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.customerName?scope.row.customerName:'新增顾客' }}
            </template>
          </el-table-column>
          <el-table-column prop="roomName" label="房间名称" show-overflow-tooltip></el-table-column>
          <el-table-column v-if="titleStatus != 1" prop="bedNumber" :label="Lib.returnRoomOrBed()+'名称'" show-overflow-tooltip></el-table-column>
          <el-table-column prop="beginTime" width="170" show-overflow-tooltip label="预使用时间" sortable="custom">
            <template slot-scope="scope">
              <span :style="scope.row.overBookTime*1 > 0 ? 'color: #F56C6C;' : ''">{{ scope.row.beginTime || '--' }}</span>
              <el-tooltip v-if="scope.row.overBookTime*1 > 0" placement="bottom" effect="light">
                <div slot="content">已超使用时间{{ scope.row.overBookTime }}</div>
                <i class="iconfont" style="color: #F56C6C;font-size: 20px;padding-left: 5px;">&#xe709;</i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="预离时间" width="170" prop="endTime" show-overflow-tooltip sortable="custom">
            <template slot-scope="scope">
              <span :style="scope.row.overTime*1 > 0 ? 'color: #F56C6C;' : ''">{{ scope.row.endTime || '--' }}</span>
              <el-tooltip v-if="scope.row.overTime*1 > 0" placement="bottom" effect="light">
                <div slot="content">已超使用时间{{ Lib.calculationTime(scope.row.overTime) }}</div>
                <i class="iconfont" style="color: #F56C6C;font-size: 20px;padding-left: 5px;">&#xe709;</i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="dateTime" label="预计使用时长" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ Lib.calculationTime(scope.row.dateTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="lookBook(scope.row)">查看预订</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-pagination background :current-page.sync="todayPageNum" :page-size="10" layout="prev, pager, next, jumper" :total="todayRowCount" @size-change="todaySwitchPageNum" @current-change="todaySwitchPageNum">
          </el-pagination>
        </div>
      </el-dialog>

      <!-- 房间记录专用 -->
      <el-dialog :title="'房间记录-'+room_title" :visible.sync="roomDialogVisible" :width="detail_dialog_width" append-to-body>
        <el-input v-model="roomSearch" style="width: 240px;" placeholder="顾客姓名/手机号码" @change="getRoomRecordsData">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-model="roomStatus" class="ml_20" @change="getRoomRecordsData">
          <el-option label="全部" value=""></el-option>
          <el-option label="已使用" value="3"></el-option>
          <el-option label="已超时" value="7"></el-option>
          <el-option label="已预订" value="2"></el-option>
          <el-option label="已过期" value="6"></el-option>
          <el-option label="已退位" value="5"></el-option>
          <el-option label="已取消" value="8"></el-option>
        </el-select>
        <el-select v-if="titleStatus != 1" v-model="roomBedNum" class="ml_20" @change="getRoomRecordsData">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(v,n) in roomBedList" :key="n" :label="v.bedNumber" :value="v.id"></el-option>
        </el-select>
        <span class="diaFrinfo">{{ date_range[0] }}至{{ date_range[1] }}</span>
        <el-table tooltip-effect="light" :data="room_table_list" style="width: 100%;margin-top: 20px;" @sort-change="roomSortChange">
          <el-table-column type="expand">
            <template slot-scope="props">
              <p style="height: 12px;line-height: 12px;">
                <span style="margin-left: 10px;">手机号码：{{ props.row.customerPhone ? Lib.starPhone(props.row.customerPhone) : '--' }}</span>
                <span v-if="props.row.createTime" style="margin-left: 10px;">预订时间：{{ props.row.createTime }}</span>
                <span v-if="props.row.remarks" style="margin-left: 10px;">备注：{{ props.row.remarks }}</span>
              </p>
              <div v-if="props.row.dtoList.length > 0">
                <p style="margin: 20px 0 0 10px;">同行人信息</p>
                <p v-for="(v,n) in props.row.dtoList" :key="n">
                  <span style="margin-left: 10px;">顾客姓名：{{ v.customerName || '--' }}</span>
                  <span style="margin-left: 10px;">手机号码：{{ v.phone || '--' }}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="customerName" label="姓名" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.customerName?scope.row.customerName:'新增顾客' }}
            </template>
          </el-table-column>
          <el-table-column prop="orderStatus" label="状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.orderStatus == 2">已预订</span>
              <span v-else-if="scope.row.orderStatus == 3">已使用</span>
              <span v-else-if="scope.row.orderStatus == 5">已退位</span>
              <span v-else-if="scope.row.orderStatus == 6">已过期</span>
              <span v-else-if="scope.row.orderStatus == 7">已超时</span>
              <span v-else>已取消</span>
            </template>
          </el-table-column>
          <el-table-column prop="beginTime" width="170" show-overflow-tooltip label="使用时间" sortable="custom">
            <template slot-scope="scope">
              <span :style="scope.row.overBookTime*1 > 0 ? 'color: #F56C6C;' : ''">{{ scope.row.beginTime || '--' }}</span>
              <el-tooltip v-if="scope.row.overBookTime*1 > 0" placement="bottom" effect="light">
                <div slot="content">已超使用时间{{ Lib.calculationTime(scope.row.overBookTime) }}</div>
                <i class="iconfont" style="color: #F56C6C;font-size: 20px;padding-left: 5px;">&#xe709;</i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" width="170" label="离店时间" show-overflow-tooltip sortable="custom">
            <template slot-scope="scope">
              <span :style="scope.row.overTime*1 > 0 ? 'color: #F56C6C;' : ''">{{ scope.row.endTime || '--' }}</span>
              <el-tooltip v-if="scope.row.overTime*1 > 0" placement="bottom" effect="light">
                <div slot="content">已超使用时间{{ Lib.calculationTime(scope.row.overTime) }}</div>
                <i class="iconfont" style="color: #F56C6C;font-size: 20px;padding-left: 5px;">&#xe709;</i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="dateTime" label="使用时长" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ Lib.calculationTime(scope.row.dateTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button v-if="scope.row.orderStatus == 3 || scope.row.orderStatus == 5 || scope.row.orderStatus == 7" type="text" @click="checkOrder(scope.row.roomOrderId,scope.row.customerOrderId,scope.row.isService,scope.row.customerPhone,scope.row.roomId,scope.row.bedId)">查看订单</el-button>
              <el-button v-else type="text" @click="lookBook(scope.row)">查看预订</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-pagination background :current-page.sync="roomRecordsPageNum" :page-size="10" layout="prev, pager, next, jumper" :total="roomRecordsRowCount" @size-change="roomRecordsSwitchPageNum" @current-change="roomRecordsSwitchPageNum">
          </el-pagination>
        </div>
      </el-dialog>

      <!-- 退房/退位专用 -->
      <el-dialog :title="titleStatus == 1 ? '退房' : '退位'" :visible.sync="outRoomdialog" width="1000px" append-to-body>
        <p class="mb_20">订单号：{{ outRoomOrBedList.orderCode }}</p>
        <el-table ref="outRoomTable" tooltip-effect="light" :data="outRoomOrBedList.dtoList" style="width: 100%;" @selection-change="chooseOutBed">
          <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
          <el-table-column prop="customerName" label="姓名">
            <template slot-scope="scope">
              <i v-show="scope.row.customerType == 0" class="iconfont">&#xea44;</i>{{ scope.row.customerName?scope.row.customerName:'新增顾客' }}
            </template>
          </el-table-column>
          <el-table-column prop="roomName" label="房间名称" />
          <el-table-column prop="beginTime" label="使用时间" />
          <el-table-column prop="endTime" label="离店时间" />
          <el-table-column prop="dateTime" label="使用时长" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.dateTime }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="outRoomdialog = false">取 消</el-button>
          <el-button type="primary" :disabled="chooseOutBedList.length > 0 ? false : true" @click="onCheckOutRoom">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="查看订单" :visible.sync="orderInfoDialog" :append-to-body="true" width="1000px">
        <order-info :order-info-data="orderInfoData" :association-list="associationList" :association-order-total="associationOrderTotal*1" :loading="loading2" @tansferDialog="getDialogData" @fatherMethod="fatherMethod"></order-info>
      </el-dialog>

      <el-dialog title="查看预订" :visible.sync="lookBookDialog" :append-to-body="true" width="1000px">
        <look-book :order-info-data="lookBookData" :loading="loading3" @tansferDialog="getLookData" @fatherMethod="triggerBtn"></look-book>
      </el-dialog>

      <div class="footFixed">
        <p @click="onBookingOrCheckIn('新增预订','')"><i class="iconfont">&#xe64a;</i>新增预订</p>
        <p @click="onBookingOrCheckIn('新增使用','')"><i class="iconfont">&#xe647;</i>新增使用</p>
        <p @click="onGetRoomDataExcel"><i class="iconfont">&#xe8aa;</i>导出房间信息</p>
        <h5 @click="todayListData"><i class="iconfont">&#xe699;</i>今日预到（{{ todayRowCount }}）</h5>
      </div>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>
<script>
import dayjs from 'dayjs'; // 这个是时间处理的包
import CountDown from 'vue2-countdown'; // 倒计时插件
import book from '../stage/template/beautyCard/template/book'; // 顾客列表
import drawer from '../publicVue/drawer'; // 筛选的弹窗
import PositiveTime from './template/positiveTime';
import orderInfo from './template/orderInfo';
import lookBook from './template/lookBook';
import {
  onBookingroom,
  onCheckOutRoom,
  onGetRoomsDetail,
  roomBedInfoList,
  onLockUpRoom,
  onUnlockRoom,
  onSetDirtyRoom,
  onCleanRoomFun,
  onBookToCheckin,
  onModificationCheckout,
  getChooseRoomInfo,
  oncheckNowStatus,
  onCancleBooking,
  getCustomerMsgList,
  getDateRoomDetails,
  getDateRoomBook,
  getRoomLogger,
  queryBedByRoomId,
  queryBookRoomOrBed,
  getRealTimeBed,
  getDateBedDetails,
  getCheckOutDetails,
  getRoomOrderMsg,
  getRoomOrderListPage,
  getBookRoomList
} from './api/index';

export default {
  name: 'RoomManagement',
  components: {
    book,
    drawer,
    CountDown,
    PositiveTime,
    orderInfo,
    lookBook,
  },
  data() {
    const validateRoom = (rule, value, callback) => {
      if (this.form.chooseRoom != undefined) {
        if (this.form.chooseRoom.length > 0) {
          callback();
        } else {
          return callback(new Error(`请选择${this.titleStatus == 2 ? '床位' : '台位'}`));
        }
      } else {
        return callback(new Error(`请选择${this.titleStatus == 2 ? '床位' : '台位'}`));
      }
    };
    const valiPhone = (rule, value, callback) => {
      if (this.form.phone == '') {
        callback();
      } else if (this.Lib.CheckPhone(this.form.phone) == true) {
        callback();
      } else {
        return callback(new Error('请输入正确的手机号码'));
      }
    };
    return {
      first_loading: false,
      loading: false,
      room_type: [
        {
          name: '使用中',
          color: 'linear-gradient(-30deg,rgba(75,156,254,1),rgba(117,180,255,1))'
        },
        {
          name: '已预订',
          color: 'linear-gradient(-30deg,rgba(255,190,53,1),rgba(252,225,101,1))'
        },
        {
          name: '锁位',
          color: 'linear-gradient(-30deg, #FF5D5D, #FF8282)'
        }
      ],
      roomListData: [], // 房间数据
      roomNumber: '', // 房间号搜索
      date_range: [
        dayjs().subtract(2, 'day').format('YYYY-MM-DD'),
        dayjs().add(29, 'day').format('YYYY-MM-DD')
      ],
      date_table_column: [
        {
          day: '',
          date: ''
        }
      ], // 放时间范围内的日期数，用来遍历表头
      // 以下是新增预订或修改的变量
      formDialogVisible: false,
      formTitle: '新增预订',
      form: {
        name: '',
        phone: '',
        now: dayjs().format('YYYY-MM-DD HH:mm'),
        endTime: '',
        memberType: 0,
        domains: [
          {
            roomId: ''
          }
        ],
        desc: '',
        chooseRoom: []
      },
      usableRoom: [],
      table_button_status: 0, // 0 锁房  1 已使用 2预订
      // 以下是详情dialog的变量
      detailDialogVisible: false,
      editableTabsValue: 'first',
      detail_table_list: [
        {
          beginTime: '',
          endTime: '',
          logInfo: [''],
          remarks: '',
          today: '',
          lastPeopleNum: 0
        }
      ],
      currentPage: 1,
      countRooms: 0,
      dtoList: [],
      max_height: 500,
      column_min_width: 103,
      radio1: '实时',
      checkinRoomsList: [], // 实时房态数据,
      activeIndex: '5',
      dropdown_y: '',
      dropdown_x: '',
      showDropdown_vis: false,
      fix_infoType: 0,
      fix_roomInfoId: null,
      detail_dialog_width: '1000px',
      today: dayjs().format('YYYY-MM-DD'),
      is_submit: false,
      isDouleBooking: 0,
      showDetailButton: true,
      bookVisible: false,
      nameStatus: 1, // 新增预订，确认使用姓名是否可以修改  1可以修改  2不可修改
      room_List: [],
      room_title: '', // 选择的房间名称
      handleRoomId: '', // 选择的房间ID
      // 筛选专用
      screen_display: false,
      screen_roomName: '',
      screen_minute: 0,
      screen_radio: '分',
      selectableRange: '00:00:00 - 23:59:59', // 限制预使用时间范围
      selectableLeaveRange: '00:00:00 - 23:59:59', // 限制预离时间范围

      // 每个状态的房间数量
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      count6: 0,
      count7: 0,
      count8: 0,
      shishitab: true,

      starPhoneVal: '',
      starStatus: 1,

      // 5.9
      resetStatus: false,

      // 5.10
      titleStatus: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位
      colleaguesDia: false, // 添加同行人弹窗
      colleaguesData: [],
      newColleaguesData: [],
      roomOptions: [],
      roomProps: {
        multiple: true, value: 'id', label: 'name', children: 'roomBedInfoList'
      },
      bedInfo: {
        cardNumber: 5,
        chooseNum: 5,
        cards: []
      },
      chooseRoomId: '',
      pageNum: 1,
      todayDialog: false,
      todayList: [], // 今日预到列表数据
      todayNumber: 0, // 今日预到超过数量
      todaySearch: '',
      todayRoomVal: '',
      todayRoomList: [],
      todayTime: '',
      todayBedVal: [],
      todayBedList: [],
      todayBedProps: {
        multiple: true, value: 'id', label: 'name', children: 'beds'
      },
      todayPageNum: 1, // 今日预到页码
      todayRowCount: 0, // 今日预到总数
      todaySortProp: '',
      todaySortOrder: '',
      rules: {
        chooseRoom: [
          { required: true, validator: validateRoom, trigger: 'change' },
          { required: true, validator: validateRoom, trigger: 'blur' }
        ],
        phone: [
          { required: false, validator: valiPhone, trigger: 'change' },
          { required: false, validator: valiPhone, trigger: 'blur' }
        ]
      },
      openListKey: [], // 同行人--展开与否
      room_table_list: [], // 房间记录--列表数据
      roomDialogVisible: false, // 房间记录--弹出窗
      roomSearch: '', // 房间记录--搜索值
      roomStatus: '', // 房间记录--状态
      roomBedNum: '', // 房间记录--床位编号
      roomBedList: [], // 床位列表
      roomRecordsPageNum: 1, // 房间记录页码数
      roomRecordsRowCount: 0, // 房间记录总数量
      roomSortProp: '',
      roomSortOrder: '',
      bed_title: '', // 选择的床位编号
      bedDialogVisible: false, // 床位详情--弹出窗口
      bedSearch: '', // 床位详情--搜索值
      bedVal: '', // 床位详情--下拉选择的值
      bedList: [], // 床位详情--下拉列表数据
      handleBedId: '', // 床位详情--选择的床位Id
      handleBedDate: '', // 床位详情--选择床位日期
      bedPageNum: 1, // 床位详情页码数
      rowCount: 0,
      bedDetailsSortProp: '',
      bedDetailsSortOrder: '',
      roomDetailsSortProp: '',
      roomDetailsSortOrder: '',
      confirmCheckData: {}, // 确认使用的数据
      outRoomOrBedList: {},
      outRoomdialog: false, // 退房--弹窗
      chooseOutBedList: [], // 退房--选择的退位列表
      chooseBedLi: '-1', // 点击选择的查看的床位
      roomDetailsPageNum: 1, // 房间详情页码数
      roomDetailsRowCount: 0, // 房间详情总数量
      roomDetailsSearch: '',
      roomDetailsStatus: '',
      roomDetailsBedNum: '',
      dropdown_num: 0,
      dropdown_type: 2,
      dropdown_row: {},
      dropdown_col: {},
      lockRoomStatus: 1, // 锁房状态，是今天之前就等于2，否则等于1
      // 6.8
      loading2: false,
      orderInfoData: {},
      orderInfoDialog: false,
      lookBookDialog: false,
      lookBookData: {},
      loading3: false,
      chooseRoomList: [],
      associationList: [],
      associationOrderTotal: 0,
      table_add: 0,
      lookBookObj: {},
      lookBookstatus: '',
    };
  },
  watch: {
    detailDialogVisible(val) {
      if (val) {
        this.editableTabsValue = 'first';
      }
    },
    formDialogVisible(val) {
      if (!val) {
        setTimeout(() => {
          this.$refs.form.resetFields();
          this.chooseRoomList = [];
        }, 300);
      } else {
        setTimeout(() => {
          // 5.2输入框文本不能选中
          const disable = document.getElementById('disableInput');
          disable.addEventListener('mousedown', (e) => {
            e.preventDefault();
          });
          disable.addEventListener('click', () => {
            disable.focus();
          });
        }, 2000);
      }
    },
    form: {
      handler(newName) {
        if (newName.now && newName.endTime) {
          if (this.formTitle === '修改') {
            this.onGetUsableRoom(newName.now, newName.endTime);
          }
        }
      },
      immediate: true,
      deep: true
    },
    screen_minute(val) {
      if (Number.isInteger(val) == false) return;
      // this.screen_minute = (this.screen_minute * 1).toFixed(0);
      this.screenInputSearch('minute');
    },
    screen_radio(val) {
      if (val == '分') {
        if (this.screen_minute * 1 > 108000) this.screen_minute = 108000;
      } else if (val == '时') {
        if (this.screen_minute * 1 > 1800) this.screen_minute = 1800;
      } else if (this.screen_minute * 1 > 30) this.screen_minute = 30;
      this.screenInputSearch('radio');
    },
    'form.phone': function (value) {
      let val = value;
      val += '';
      if (this.starStatus == 2 && window.sessionStorage.isHidePhone == 1) {
        this.starPhoneVal = val.length == 4 ? '*' : val.length == 5 ? '**' : val.length == 6 ? '***' : val.length > 6 ? '****' : '';
      } else {
        this.starPhoneVal = '';
      }
      if (val.length < 4) {
        this.starStatus = 1;
      }
    }
  },
  activated() {
    setTimeout(() => {
      this.max_height = document.body.clientHeight - 215;
    }, 1000);
    this.titleStatus = window.sessionStorage.tidyStatus;
    this.activeIndex = '5';
    this.getTodayListData();
    if (this.radio1 === '远期') {
      sessionStorage.setItem('date_range', this.date_range);
      this.currentPage = 1;
      this.onGetRoomListData();
    } else {
      this.onChangeOverlap('实时', this.activeIndex);
    }
    // 监听滚动
    let tempLeft = 0;
    this.$refs.main_table.bodyWrapper.addEventListener(
      'scroll',
      (res) => {
        const height = res.target;
        const { clientHeight } = height;
        const { scrollTop } = height;
        const { scrollHeight } = height;
        // 当滚动到底部 而且 不是水平滚动的时候
        if (clientHeight + scrollTop === scrollHeight && tempLeft === res.target.scrollLeft && this.titleStatus == 1) {
          setTimeout(() => {
            this.onGetRoomListData();
          }, 200);
        }
        this.showDropdown_vis = false;
        tempLeft = res.target.scrollLeft;
      },
      true
    );
  },
  methods: {
    fatherMethod(val) {
      if (val.status == 1) {
        this.roomOutList(val.obj.checkinRoom);
      } else if (val.status == 2) {
        this.undateRoomerDetail(val.obj.checkinRoom);
      } else if (val.status == 3) {
        this.getRoomOrderListPage(val.pageNum, val.phone, val.roomId, val.bedId, val.roomOrderId);
      }
    },
    triggerBtn(val) {
      if (val.status == 1) {
        this.onCancelCheckIn(val.obj);
      } else if (val.status == 2) {
        this.undateRoomerDetail(val.obj);
      } else if (val.status == 3) {
        this.isConfirmCheckIn(val.obj);
      }
    },
    // 查看预订
    lookBook(obj, status) {
      this.lookBookObj = obj;
      this.lookBookstatus = status;
      const nData = {
        roomOrBedId: this.titleStatus == 1 ? obj.roomId : obj.bedId,
        mainId: sessionStorage.getItem('mainId'),
        roomType: this.titleStatus == 1 ? 1 : 2,
        pageNum: 1,
        pageSize: 1000,
        phone: this.lookBookstatus == 2 ? '' : obj.customerPhone,
        beginTime: obj.beginTime || obj.createTime,
        endTime: obj.endTime,
      };
      this.loading3 = true;
      this.lookBookDialog = true;
      getBookRoomList(nData).then((res) => {
        if (res.code === 0) {
          this.lookBookData = res.data;
          this.loading3 = false;
        }
      });
    },
    // 查看订单
    checkOrder(roomOrderId, orderId, isService, phone, roomId, bedId) {
      const nData = {
        roomOrderId,
        orderId,
        isService
      };
      this.loading2 = true;
      this.orderInfoDialog = true;
      getRoomOrderMsg(nData).then((res) => {
        if (res.code === 0) {
          res.data.itemList = res.data.itemList ? res.data.itemList : [];
          res.data.itemList.forEach((a) => {
            a.refundNum = '0';
            a.refundCount = '0';
            a.refundMoney = a.resultPrice;
          });
          res.data.refundStatus = res.data.refundStatus ? res.data.refundStatus : 0;
          this.orderInfoData = res.data;
          this.getRoomOrderListPage(1, phone, roomId, bedId, roomOrderId);
        }
      });
    },
    // 获取关联订单数据
    getRoomOrderListPage(pageNum, phone, roomId, roomBedId, roomOrderId) {
      const gData = {
        pageNum,
        pageSize: 5,
        phone,
        roomId,
        roomBedId: roomBedId || null,
        roomOrderId,
      };
      getRoomOrderListPage(gData).then((resTwo) => {
        if (resTwo.code === 0) {
          this.associationList = resTwo.data.records;
          this.associationOrderTotal = resTwo.data.total;
          this.loading2 = false;
        }
      });
    },
    getDialogData(list) {
      this.orderInfoDialog = list;
    },
    getLookData(list) {
      this.lookBookDialog = list;
    },
    // 检查手机号码正确与否
    checkPhone(val, index, status, n) {
      if (val && !this.Lib.CheckPhone(val)) {
        this.$message('您输入的手机号码有误，请重新输入');
        if (status == 1) {
          this.newColleaguesData[index].phone = '';
        } else {
          this.newColleaguesData[index].chooseList[n].phone = '';
        }
      }
    },
    // 今日预到排序事件
    todaySortChange({ prop, order }) {
      this.todaySortProp = prop;
      this.todaySortOrder = order;
      this.todaySwitchPageNum(1);
    },
    // 今日预到列表--弹窗
    todayListData() {
      this.todayDialog = true;
      this.showDropdown_vis = false;
      queryBookRoomOrBed({ mainId: sessionStorage.getItem('mainId') }).then((res) => {
        if (res.code == 0) {
          if (this.titleStatus == 1) {
            this.todayRoomList = res.data;
          } else {
            this.todayBedList = res.data;
          }
        } else {
          console.log(res);
        }
      });
      this.getTodayListData();
    },
    todaySwitchPageNum(val) {
      this.todayPageNum = val;
      this.getTodayListData();
    },
    // 获取今日预到列表数据
    getTodayListData() {
      const arr = [];
      this.todayBedVal.forEach((a) => {
        arr.push(a[1]);
      });
      const data = {
        isAsc: this.todaySortOrder == 'ascending' ? 1 : this.todaySortOrder == 'descending' ? 0 : null,
        mainId: sessionStorage.getItem('mainId'),
        orderType: this.todaySortProp == 'beginTime' ? 1 : this.todaySortProp == 'endTime' ? 2 : null,
        keyWord: this.todaySearch,
        roomOrBed: this.titleStatus == 1 ? (this.todayRoomVal ? [this.todayRoomVal] : null) : arr.length == 0 ? null : arr,
        dateTime: this.todayTime,
        pageNum: this.todayPageNum,
        pageSize: 10
      };
      getDateRoomBook(data).then((res) => {
        if (res.code == 0) {
          this.todayList = res.data.dtoPage.records;
          this.todayRowCount = res.data.dtoPage.total;
          this.todayNumber = res.data.number;
        } else {
          console.log(res);
        }
      });
    },
    // 选择床位--5.10
    chooseBed(id) {
      this.chooseRoomId = id;
      if (id == '') this.chooseBedLi = '-1';
    },
    getRoomOrderId(arr, roomId, bedId) {
      let val = '';
      arr.forEach((a) => {
        if (a.roomId == roomId && a.bedId == bedId) {
          val = a.roomOrderId;
        }
      });
      return val;
    },
    getCustomerId(arr, roomId, bedId) {
      let val = '';
      arr.forEach((a) => {
        if (a.roomId == roomId && a.bedId == bedId) {
          val = a.customerId;
        }
      });
      return val;
    },
    chooseCascader() {
      const arr = [];
      this.form.chooseRoom.forEach((a, n) => {
        this.roomOptions.forEach((b) => {
          if (a[0] == b.id) {
            b.roomBedInfoList.forEach((c) => {
              if (a[1] == c.id) {
                const obj = {};
                obj.customerId = this.getCustomerId(this.form.domains, b.id, c.id);
                obj.roomOrderId = this.getRoomOrderId(this.form.domains, b.id, c.id);
                obj.roomId = b.id;
                obj.roomName = b.name;
                obj.bedId = c.id;
                obj.bedNum = c.name;
                obj.phone = n == 0 ? this.form.phone : this.colleaguesData[n] ? this.colleaguesData[n].phone : '';
                obj.name = n == 0 ? this.form.name : this.colleaguesData[n] ? this.colleaguesData[n].name : '';
                obj.chooseList = this.colleaguesData[n] ? this.colleaguesData[n].chooseList : [];
                arr.push(obj);
              }
            });
          }
        });
      });
      this.colleaguesData = arr;
      this.$forceUpdate();
    },
    confirmCancel() {
      this.colleaguesDia = false;
    },
    confirmAdd() {
      this.colleaguesDia = false;
      this.colleaguesData = JSON.parse(JSON.stringify(this.newColleaguesData));
      this.checkList();
    },
    // 添加或者删除同行人
    addAndSubMember(val, index, num) {
      if (val == 1) {
        this.newColleaguesData[index].chooseList.push({ name: '', phone: '' });
      } else {
        this.newColleaguesData[index].chooseList.splice(num, 1);
      }
      this.checkList();
    },
    // 5.10校验展开列表
    checkList() {
      this.openListKey = [];
      this.newColleaguesData.forEach((a) => {
        if (a.chooseList.length > 0) {
          this.openListKey.push(a.id);
        }
      });
    },
    // 5.10  添加同行人--弹出窗
    addColleagues() {
      this.colleaguesDia = true;
      this.colleaguesData.forEach((v, n) => {
        if (n == 0) {
          v.name = this.form.name;
          v.phone = this.form.phone;
        }
      });
      this.newColleaguesData = JSON.parse(JSON.stringify(this.colleaguesData));
      if (this.titleStatus == 1) {
        this.roomInfoChange();
      } else {
        this.chooseCascader();
      }
      this.checkList();
    },
    // 修改date_range时间范围
    onDateChange(val) {
      const day1 = dayjs(val[1]);
      const day2 = dayjs(val[2]);
      const diffDay = day2.diff(day1, 'day');
      // 如果超过 50天就报超出范围的错
      if (Math.abs(diffDay) > 50) {
        this.$message({
          showClose: true,
          message: '可选择天数范围不可超过50日',
          type: 'error'
        });
        this.date_range = sessionStorage.getItem('date_range').split(',');
        return;
      }
      this.is_submit = false;
      this.currentPage = 1;
      this.date_table_column = [{}];
      this.roomListData = [];
      sessionStorage.setItem('date_range', val);
      this.onGetRoomListData();
    },
    // 获取date_range时间范围内房间列表
    onGetRoomListData() {
      // 请求接口
      const data = {
        beginTime: this.date_range[0],
        endTime: this.date_range[1],
        mainId: sessionStorage.getItem('mainId'),
        roomName: this.screen_roomName,
        pageSize: 10,
        pageNo: this.currentPage
      };
      if (this.titleStatus == 1) {
        // is_sumit 作用是如果发现有一页是空的 就控制不再请求接口 5-28
        if (!this.is_submit) {
          this.is_submit = true;
        } else {
          return false;
        }
        if (this.currentPage === 1) {
          this.loading = true;
          this.roomListData = [];
        }
        onGetRoomsDetail(data).then((res) => {
          this.loading = false;
          if (Number(res.code) === 0) {
            this.is_submit = false;
            if (this.currentPage === 1) {
              this.roomListData = [];
            }
            this.countRooms = res.data.countRooms;
            this.dtoList = res.data.dtoList;
            for (let i = 0; i < res.data.rooms.length; i++) {
              for (let j = 0; j < res.data.rooms[i].timeDatas.length; j++) {
                if (res.data.rooms[i].timeDatas[j].roomInfos.length > 0) {
                  if (res.data.rooms[i].timeDatas[j].roomInfos[0].roomStatus === 5) {
                    const ndata = res.data.rooms[i].timeDatas[j].roomInfos.shift();
                    res.data.rooms[i].timeDatas[j].roomInfos.push(ndata);
                  }
                }
                res.data.rooms[i].timeDatas[j].roomInfos.sort((a, b) => a.isDelete - b.isDelete);
              }
              this.roomListData.push(Object.freeze(res.data.rooms[i]));
            }

            this.first_loading = true;
            if (res.data.rooms.length > 0) {
              this.currentPage += 1;
            } else {
              this.is_submit = true;
            }
          }
        });
      } else {
        roomBedInfoList(data).then((res) => {
          if (res.code == 0) {
            this.dtoList = res.data.dtoList;
            res.data.roomBedList.forEach((a) => {
              a.timeDatas = a.bedInfoList;
            });
            this.roomListData = res.data.roomBedList;
            this.first_loading = true;
          } else {
            console.log();
          }
        });
      }

      if (this.date_table_column.length != 0) {
        // returnDate 获得第几天
        const returnDate = new Date(data.beginTime).getDate();
        const dayChineseVer = ['日', '一', '二', '三', '四', '五', '六'];

        // 清空数组
        this.date_table_column = [];
        // 由于for循环遍历不出第一天 所以date_table_column先存放第一天
        const obj = {
          day: dayChineseVer[dayjs(data.beginTime).format('d')],
          date: data.beginTime
        };
        this.date_table_column.push(obj);
        // 这里写个for,用来输出每一天
        for (let i = 0, len = dayjs(this.date_range[1]).diff(dayjs(this.date_range[0]), 'day'); i < len; i++) {
          const nObj = {
            day: dayChineseVer[dayjs(new Date(data.beginTime).setDate(returnDate + (i + 1))).format('d')],
            date: dayjs(new Date(data.beginTime).setDate(returnDate + (i + 1))).format('YYYY-MM-DD')
          };
          this.date_table_column.push(nObj);
        }
      }
    },
    // 控制表头换行
    renderheader(h, { column }) {
      // 空格换行
      return h('p', {}, [
        h('span', column.label.split(' ')[0]),
        h('br'),
        h('span', column.label.split(' ')[1]),
        h('br'),
        h('b', {
          attrs: {
            class: 'header_room', // ele原来样式
            style: 'height: 19px;display: block;'
          },
          domProps: {
            innerHTML:
              `${column.label.split(' ')[2].substring(0, 2)
              }<span style="color: #fd5c8c;font-weight:bold">${
                column.label
                  .split(' ')[2]
                  .substring(2, column.label.split(' ')[2].length - 1)
              }</span>${
                column.label
                  .split(' ')[2]
                  .substring(
                    column.label.split(' ')[2].length - 1,
                    column.label.split(' ')[2].length
                  )}`
          }
        })
      ]);
    },
    // 表头样式
    headerStyle({ column }) {
      if (column.label) {
        // 周日分隔样式
        if (column.label.substring(6, 8) === '周日') {
          return 'border-right:3px solid #cdd4d9;';
        }
      }
    },
    // 单元格样式
    cellStyle({ row, column }) {
      if (this.titleStatus == 1) {
        if (column.label) {
          const len = row.timeDatas.length;
          if (len != 0) {
            const temp = row.timeDatas;
            const roomIndex = temp.find(
              (x) => x.today === column.label.substring(0, 10)
            );

            if (roomIndex != undefined) {
              if (roomIndex.roomInfos.findIndex((x) => x.roomStatus === 1) != -1) {
                roomIndex.roomInfos[0] = roomIndex.roomInfos.find(
                  (x) => x.roomStatus === 1
                );
              }
              if (roomIndex.roomInfos.length != 0) {
                if (roomIndex.roomInfos[0].isDelete === 1) {
                  return;
                }
                switch (roomIndex.roomInfos[0].roomStatus) {
                // 1锁定 2已预订 3已使用 4置脏 5已离店 6已过期 7超时  8取消
                  case 1:
                  // 锁定
                    return 'background: linear-gradient(-30deg, rgb(255, 93, 93), rgb(255, 130, 130));color:#FFFFFF!important;';
                  case 2:
                  // 预订
                    return 'background: linear-gradient(-30deg,rgba(255,190,53,1),rgba(252,225,101,1));color:#FFFFFF!important;';
                  case 3:
                  // 使用
                    return 'background: linear-gradient(-30deg,rgba(75,156,254,1),rgba(117,180,255,1));color: #FFFFFF!important;';
                  case 6:
                  // 已过时
                    return 'background: white';
                  case 7:
                  // 已超时
                    return 'background: linear-gradient(-30deg,rgba(124,126,255,1),rgba(143,146,255,1));color: #FFFFFF!important;';
                  default:
                    break;
                }
              }
            }
          }
        }
      } else if (column.label) {
        const len = row.bedInfoList.length;
        if (len != 0) {
          const temp = row.bedInfoList;
          const roomIndex = temp.find(
            (x) => x.dateTime === column.label.substring(0, 10)
          );

          if (roomIndex != undefined) {
            switch (roomIndex.roomStatus) {
              // 1锁定 2已预订 3已使用 4置脏 5已离店 6已过期 7超时  8取消
              case 1:
                // 锁定
                return 'background: linear-gradient(-30deg, rgb(255, 93, 93), rgb(255, 130, 130));color:#FFFFFF!important;';
              case 2:
                // 预订
                return 'background: linear-gradient(-30deg,rgba(255,190,53,1),rgba(252,225,101,1));color:#FFFFFF!important;';
              case 3:
                // 使用
                return 'background: linear-gradient(-30deg,rgba(75,156,254,1),rgba(117,180,255,1));color: #FFFFFF!important;';
              case 6:
                // 已过时
                return 'background: white';
              case 7:
                // 已超时
                return 'background: linear-gradient(-30deg,rgba(124,126,255,1),rgba(143,146,255,1));color: #FFFFFF!important;';
              default:
                break;
            }
          }
          if (row.roomOrBed == 1) {
            return 'background-color: #F5F7FA;color: #333!important;';
          }
        }
      }
    },
    // 表头class
    headerClass({ column }) {
      if (column.label) {
        // 当天时间列表头边框样式当天时间列边框样式class
        if (column.label.substring(0, 10) === dayjs().format('YYYY-MM-DD')) {
          return 'header_class';
        }
        // 周日边框样式class
        if (column.label.substring(11, 13) === '周日') {
          return 'sunday_class';
        }
      }
    },
    // 单元格class
    cellClass({ column }) {
      if (column.label) {
        // 当天时间列边框样式class
        if (column.label.substring(0, 10) === dayjs().format('YYYY-MM-DD')) {
          return 'cell_class';
        }
        // 周日边框样式class
        if (column.label.substring(11, 13) === '周日') {
          return 'sunday_class';
        }
      }
    },
    // 鼠标进入和离开单元格
    clickCell(row, column, cell) {
      if (cell.style.border === '') {
        // eslint-disable-next-line no-return-assign
        return (cell.style.border = '1px solid red');
      }
      // eslint-disable-next-line no-return-assign
      return (cell.style.border = '');
    },
    // 算出天数差
    ToCountHowManyDay(date) {
      return dayjs(date[1]).diff(dayjs(date[0]), 'days');
    },
    // 显示可用房间
    onGetUsableRoom(beginTime, endTime, item) {
      const vm = this;
      const data = {
        mainId: sessionStorage.getItem('mainId'),
        beginTime,
        endTime,
        roomOrderId: this.fix_roomInfoId
      };
      if (vm.titleStatus == 1) {
        getChooseRoomInfo(data).then((res) => {
          vm.room_List = res.data.chooseRoomInfoList;
          if (item) {
            const arr = [];
            this.form.domains.forEach((a) => {
              this.room_List.forEach((b) => {
                if (a.roomId == b.id) {
                  const obj = {};
                  obj.customerId = a.customerId;
                  obj.roomOrderId = a.roomOrderId;
                  obj.roomId = b.id;
                  obj.roomName = b.name;
                  obj.bedId = '';
                  obj.bedNum = '';
                  obj.phone = item.customerPhone;
                  obj.name = item.customerName;
                  obj.chooseList = [];
                  if (item.dtoList) {
                    item.dtoList.forEach((c) => {
                      obj.chooseList.push({ customerId: c.customerId, name: c.name, phone: c.phone });
                    });
                  }
                  arr.push(obj);
                }
              });
            });
            this.colleaguesData = arr;
          }
        });
      } else {
        getChooseRoomInfo(data).then((res) => {
          if (res.code == 0) {
            vm.roomOptions = res.data.chooseRoomInfoList;
            const arr = [];
            vm.form.chooseRoom.forEach((a, n) => {
              vm.roomOptions.forEach((b) => {
                if (a[0] == b.id) {
                  b.roomBedInfoList.forEach((c) => {
                    if (a[1] == c.id) {
                      const obj = {};
                      obj.customerId = this.getCustomerId(this.form.domains, b.id, c.id);
                      obj.roomOrderId = this.getRoomOrderId(this.form.domains, b.id, c.id);
                      obj.roomId = b.id;
                      obj.roomName = b.name;
                      obj.bedId = c.id;
                      obj.bedNum = c.name;
                      obj.phone = n == 0 ? this.form.phone : vm.colleaguesData[n] ? vm.colleaguesData[n].phone : '';
                      obj.name = n == 0 ? this.form.name : vm.colleaguesData[n] ? vm.colleaguesData[n].name : '';
                      obj.chooseList = vm.colleaguesData[n] ? vm.colleaguesData[n].chooseList : [];
                      arr.push(obj);
                    }
                  });
                }
              });
            });
            vm.colleaguesData = arr;
          } else {
            console.log(res);
          }
        });
      }
    },
    // 新增预订房间信息
    onConfirmFormDialog() {
      if (!this.validateTime(this.form.now, this.form.endTime)) {
        this.$message({
          showClose: true,
          message: '时间选择有误或超时,请重新选择时间',
          type: 'error'
        });
        this.form.endTime = '';
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.compareCurrentTimeVal(this.form.endTime) < 10) {
            this.$message('预使用时间与预离时间间隔不能小于十分钟');
            return;
          }
          const arr = [];
          if (this.titleStatus == 1) {
            this.form.domains.forEach((a, n) => {
              this.colleaguesData.forEach((b, m) => {
                if (n === m) {
                  const obj = {};
                  obj.customerId = a.customerId;
                  obj.roomOrderId = a.roomOrderId;
                  obj.beginTime = this.form.now;
                  obj.customerName = this.form.name;
                  obj.customerPhone = this.form.phone;
                  obj.customerType = m == 0 ? 0 : 1;
                  const nArr = [{ name: (b.name || '同行顾客'), phone: b.phone }];
                  b.chooseList.forEach((c) => {
                    if (c.name == '') {
                      c.name = '同行顾客';
                    }
                    nArr.push(c);
                  });
                  obj.dtoList = (m == 0 ? b.chooseList : nArr);
                  obj.endTime = this.form.endTime;
                  obj.mainId = sessionStorage.getItem('mainId');
                  obj.memberType = m == 0 ? this.form.memberType : 0;
                  obj.remarks = this.form.desc;
                  obj.roomBedId = '';
                  obj.roomId = b.roomId;
                  arr.push(obj);
                }
              });
            });
          } else {
            this.colleaguesData.forEach((a, n) => {
              const obj = {};
              obj.customerId = a.customerId;
              obj.roomOrderId = a.roomOrderId;
              obj.beginTime = this.form.now;
              obj.customerName = n == 0 ? this.form.name : (a.name || '同行顾客');
              obj.customerPhone = n == 0 ? this.form.phone : a.phone;
              obj.customerType = n == 0 ? 0 : 1;
              obj.dtoList = [];
              obj.endTime = this.form.endTime;
              obj.mainId = sessionStorage.getItem('mainId');
              obj.memberType = n == 0 ? this.form.memberType : 0;
              obj.remarks = this.form.desc;
              obj.roomBedId = a.bedId;
              obj.roomId = a.roomId;
              arr.push(obj);
            });
          }
          onBookingroom(JSON.stringify(arr)).then((res) => {
            if (Number(res.code) === 0) {
              if (this.radio1 === '远期') {
                this.is_submit = false;
                this.currentPage = 1;
                this.onGetRoomListData();
              } else {
                this.activeIndex = '5';
                this.onChangeOverlap('实时', this.activeIndex);
              }
              setTimeout(() => {
                this.$refs.form.resetFields();
              }, 300);
              // this.$refs["form"].resetFields();
              this.formDialogVisible = false;
              this.$message({
                showClose: true,
                message: '预订成功',
                type: 'success'
              });
              this.todaySwitchPageNum(1);
            }
          });
        }
        return false;
      });
    },
    // 关闭预订/修改房间dialog
    onCloseFormDialog() {
      this.formDialogVisible = false;
      this.nameStatus = 1;
      this.formTitle = '新增预订';
      this.editableTabsValue = 'first';
    },
    // 返回剩余房间数
    returnNewLeftRoomNum(date) {
      let num = 0;
      this.dtoList.forEach((a) => {
        if (a.dateTime == date) {
          num = a.bookPepNum;
        }
      });
      return num;
    },
    // 返回预订人数或已用人数--房间模式
    returnRoomerName(scope, date, val) {
      if (scope.row.timeDatas.length != 0) {
        const temp = scope.row.timeDatas.find((x) => x.today === date);
        if (!temp) return;
        if (!temp.roomInfos) return;
        if (temp.roomInfos.length == 0) return;
        if (temp != undefined && temp.roomInfos[0].isDelete === 0 && temp.roomInfos[0].roomStatus != 5 && temp.roomInfos[0].roomStatus !== 6
          && temp.roomInfos[0].roomStatus != 1) {
          if (val == 1) {
            return `预订：${temp.bookNumber}人`;
          }
          return `已用：${temp.checkInNumber}人`;
        }
      }
    },
    // 返回预订人数或已用人数--床位模式
    returnBedName(scope, date, val) {
      if (scope.row.bedInfoList.length != 0) {
        const temp = scope.row.bedInfoList.find((x) => x.dateTime === date);
        if (val == 1 && (temp.bookPepNum || temp.checkInNum)) {
          return `预订：${temp.bookPepNum}人`;
        }
        if (val == 2 && (temp.bookPepNum || temp.checkInNum)) {
          return `已用：${temp.checkInNum}人`;
        }
        if (val == 0 && temp.bookPepNum) {
          return `预订：${temp.bookPepNum}人`;
        }
        if (val == 0 && !temp.bookPepNum) {
          return '无预订';
        }
      }
    },
    // 点击单元格下拉框选择事件
    handleCommand(command, scope, column) {
      console.log(command, scope, column);
      this.showDropdown_vis = false;
      this.room_title = scope.roomName;
      this.handleRoomId = scope.roomId;
      this.bed_title = scope.bedNumber;
      this.handleBedId = scope.bedId;
      this.handleBedDate = column.label ? column.label.substring(0, 10) : '';
      switch (command) {
        case 'b':
          this.onGetDateBedDetails();
          break;
        case 'd':
          this.onSetDirtyRoom(scope, column);
          break;
        case 'e':
          this.onCleanRoomFun(scope, column);
          break;
        case 'j':
          this.onUnlockRoom(scope, column);
          break;
        case 'p':
          this.getRoomDetailsData(scope);
          break;
        case 's':
          this.onLockupRoomFun(scope, column, scope.roomId, scope.bedId);
          break;
        case 'r':
          this.getRoomRecords();
          break;
        case 'x':
          this.onBookingOrCheckIn('新增预订', scope.roomId, scope.bedId, scope);
          break;
        case 'y':
          this.onBookingOrCheckIn('新增使用', scope.roomId, scope.bedId, scope);
          break;
        default:
          break;
      }
    },
    // 房间记录排序事件
    roomSortChange({ prop, order }) {
      this.roomSortProp = prop;
      this.roomSortOrder = order;
      this.roomRecordsSwitchPageNum(1);
    },
    // 获取房间记录列表数据--弹窗加请求床位
    getRoomRecords() {
      this.roomDialogVisible = true;
      queryBedByRoomId({ roomId: this.handleRoomId }).then((res) => {
        if (res.code == 0) {
          this.roomBedList = res.data;
        } else {
          console.log(res);
        }
      });
      this.getRoomRecordsData();
    },
    roomRecordsSwitchPageNum(val) {
      this.roomRecordsPageNum = val;
      this.getRoomRecordsData();
    },
    // 获取房间记录列表数据
    getRoomRecordsData() {
      const data = {
        roomId: this.handleRoomId,
        beginTime: this.date_range[0],
        endTime: this.date_range[1],
        pageNum: this.roomRecordsPageNum,
        pageSize: 10,
        keyWord: this.roomSearch,
        roomStatus: this.roomStatus,
        bedId: this.roomBedNum,
        mainId: sessionStorage.getItem('mainId'),
        orderType: this.roomSortProp == 'beginTime' ? 1 : this.roomSortProp == 'endTime' ? 2 : null,
        isAsc: this.roomSortOrder == 'ascending' ? 1 : this.roomSortOrder == 'descending' ? 0 : null,
      };
      getRoomLogger(data).then((res) => {
        if (res.code == 0) {
          this.room_table_list = res.data.records;
          this.roomRecordsRowCount = res.data.total;
        } else {
          console.log();
        }
      });
    },
    // 查看远期房间详情
    onGetRoomDetail(row, column, event) {
      if (this.titleStatus == 1) {
        this.detail_table_list = [];
        const arrFirst = this.roomListData.filter((x) => x.roomName === row.roomName);
        const arrSecond = arrFirst[0].timeDatas.filter((x) => x.today === column.label.substring(0, 10));
        this.room_title = row.roomName;
        const newData = JSON.parse(JSON.stringify(arrSecond[0].roomInfos));
        newData.forEach((a) => {
          if (a.roomStatus == 1) {
            a.roomStatus = '已锁房';
          } else if (a.roomStatus == 2) {
            a.roomStatus = '已预订';
          } else if (a.roomStatus == 3) {
            a.roomStatus = '已入住';
          } else if (a.roomStatus == 5) {
            a.roomStatus = this.titleStatus == 1 ? '已退房' : '已退位';
          } else if (a.roomStatus == 6) {
            a.roomStatus = '已过期';
          } else if (a.roomStatus == 7) {
            a.roomStatus = '已超时';
          } else if (a.roomStatus == 8) {
            a.roomStatus = '已取消';
          }
        });
        this.detail_table_list = newData;
        this.detailDialogVisible = true;
      } else {
        this.dropdown_x = `${event.clientX}px`;
        this.dropdown_y = `${event.clientY}px`;
        this.showDropdown_vis = true;
        this.dropdown_row = row;
        this.dropdown_col = column;
        this.showDetailButton = true;
      }
    },
    // 房间详情排序事件
    roomDetailsSortChange({ prop, order }) {
      this.roomDetailsSortProp = prop;
      this.roomDetailsSortOrder = order;
      this.roomDetailsSwitchPageNum(1);
    },
    // 获取房间记录列表数据
    getRoomDetailsData(item) {
      this.room_title = item.roomName;
      this.detailDialogVisible = true;
      this.handleRoomId = item.roomId;
      queryBedByRoomId({ roomId: this.handleRoomId }).then((res) => {
        if (res.code == 0) {
          this.roomBedList = res.data;
        } else {
          console.log(res);
        }
      });
      this.roomDetailsSwitchPageNum(1, item);
    },
    // 房间详情列表数据--切换页码
    roomDetailsSwitchPageNum(val, item) {
      this.roomDetailsPageNum = val;
      this.onGetshishiRoomDetail(item);
    },
    // 查看房间详情
    onGetshishiRoomDetail(room) {
      const data = {
        roomId: room ? room.roomId : this.handleRoomId,
        pageNum: this.roomDetailsPageNum,
        pageSize: 10,
        mainId: sessionStorage.getItem('mainId'),
        dateTime: this.handleBedDate || this.today,
        roomStatus: this.roomDetailsStatus,
        bedId: this.titleStatus == 1 ? '' : (room ? room.bedId : this.roomDetailsBedNum),
        keyWord: this.roomDetailsSearch,
        orderType: this.roomDetailsSortProp == 'beginTime' ? 1 : this.roomDetailsSortProp == 'endTime' ? 2 : null,
        isAsc: this.roomDetailsSortOrder == 'ascending' ? 1 : this.roomDetailsSortOrder == 'descending' ? 0 : null,
      };
      getDateRoomDetails(data).then((res) => {
        if (res.code == 0) {
          res.data.records.forEach((x) => {
            x.lastPeopleNum = x.lastRoomNum;
          });
          this.detail_table_list = res.data.records;
          this.roomDetailsRowCount = res.data.total;
        } else {
          console.log();
        }
      });
    },
    // 床位详情排序事件
    bedDetailsSortChange({ prop, order }) {
      this.bedDetailsSortProp = prop;
      this.bedDetailsSortOrder = order;
      this.switchPageNum(1);
    },
    switchPageNum(val) {
      this.bedPageNum = val;
      this.onGetDateBedDetails();
    },
    // 查看远期床位详情
    onGetDateBedDetails() {
      const data = {
        bedId: this.handleBedId,
        pageNum: this.bedPageNum,
        pageSize: 10,
        mainId: sessionStorage.getItem('mainId'),
        dateTime: this.handleBedDate || this.today,
        roomStatus: this.bedVal,
        keyWord: this.bedSearch,
        orderType: this.bedDetailsSortProp == 'beginTime' ? 1 : this.bedDetailsSortProp == 'endTime' ? 2 : null,
        isAsc: this.bedDetailsSortOrder == 'ascending' ? 1 : this.bedDetailsSortOrder == 'descending' ? 0 : null,
      };
      getDateBedDetails(data).then((res) => {
        if (res.code == 0) {
          this.rowCount = res.data.total;
          if (res.data.records.length > 0) {
            this.room_title = res.data.records[0].roomName;
          }
          res.data.records.forEach((x) => {
            x.lastPeopleNum = x.lastRoomNum;
          });
          this.detail_table_list = res.data.records;
        } else {
          this.detail_table_list = [];
        }
        this.bedDialogVisible = true;
      });
    },
    // 修改房客信息
    undateRoomerDetail(item) {
      if (this.Lib.checkPower('beauty-2-xgsyxx') == false) return;
      this.fix_infoType = item.roomStatus == '已使用' ? 3 : item.roomStatus == '已预订' ? 2 : item.roomStatus == '已超时' ? 7 : item.roomStatus;
      this.fix_roomInfoId = item.roomInfoId ? item.roomInfoId : item.roomOrderId;
      this.detailDialogVisible = false;
      this.formTitle = '修改';
      this.formDialogVisible = true;
      this.form = {
        customerId: item.customerId,
        name: item.customerName,
        phone: item.customerPhone,
        now: item.beginTime,
        endTime: item.endTime,
        roomOrderId: item.roomOrderId,
        memberType: item.memberType,
        chooseRoom: [
          [item.roomId, item.bedId]
        ],
        domains: [
          {
            customerId: item.customerId,
            bedId: item.bedId,
            roomId: item.roomId,
            beginTime: item.beginTime,
            endTime: item.endTime,
            roomOrderId: item.roomOrderId
          }
        ],
        dtoList: item.dtoList || [],
        desc: item.remarks
      };
      this.chooseRoomList = [item.roomId];
      this.confirmCheckData = JSON.parse(JSON.stringify(this.form));
      this.onGetUsableRoom(item.beginTime, item.endTime, item);
    },
    // 修改信息
    onChangeRoom() {
      if (this.compareCurrentTimeVal(this.form.endTime) < 10) {
        this.$message('预使用时间与预离时间间隔不能小于十分钟');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = {
            customerIds: [],
            roomOrderIdList: [],
            editList: [],
            mainId: sessionStorage.getItem('mainId')
          };
          if (this.titleStatus == 1) {
            this.form.domains.forEach((a, n) => {
              this.colleaguesData.forEach((b, m) => {
                if (n === m) {
                  const obj = {};
                  obj.customerId = a.customerId;
                  obj.roomOrderId = a.roomOrderId;
                  obj.beginTime = this.form.now;
                  obj.customerName = this.form.name;
                  obj.customerPhone = this.form.phone;
                  obj.customerType = m == 0 ? 0 : 1;
                  const nArr = [{ name: (b.name || '同行顾客'), phone: b.phone }];
                  b.chooseList.forEach((c) => {
                    if (c.name == '') {
                      c.name = '同行顾客';
                    }
                    nArr.push(c);
                  });
                  obj.dtoList = (m == 0 ? b.chooseList : nArr);
                  obj.endTime = this.form.endTime;
                  obj.roomOrderId = a.roomOrderId;
                  obj.roomStatus = this.fix_infoType == 7 ? 3 : this.fix_infoType;
                  obj.memberType = m == 0 ? this.form.memberType : 0;
                  obj.remarks = this.form.desc;
                  obj.roomBedId = '';
                  obj.roomId = b.roomId;
                  data.editList.push(obj);
                }
              });
            });
            const aggregateOne = [];
            const aggregateTwo = [];
            const aggregateThree = [];
            const aggregateFour = [];
            this.confirmCheckData.dtoList.forEach((a) => {
              if (a.customerType == 1) {
                aggregateOne.push(a.customerId);
              }
              aggregateThree.push(a.roomOrderId);
            });
            console.log(this.confirmCheckData.dtoList, this.colleaguesData);
            if (this.colleaguesData) {
              this.colleaguesData.forEach((c) => {
                c.chooseList.forEach((d) => {
                  if (d.customerId) {
                    aggregateTwo.push(d.customerId);
                  }
                });
                aggregateFour.push(c.roomOrderId);
              });
            }
            data.customerIds = [...aggregateOne].filter((x) => [...aggregateTwo].every((y) => y !== x));
            data.roomOrderIdList = [...aggregateThree].filter((x) => [...aggregateFour].every((y) => y !== x));
          } else {
            this.colleaguesData.forEach((a, n) => {
              const obj = {};
              obj.customerId = a.customerId;
              obj.roomOrderId = a.roomOrderId;
              obj.beginTime = this.form.now;
              obj.customerName = a.name || '同行顾客';
              obj.customerPhone = a.phone;
              obj.customerType = n == 0 ? 0 : 1;
              obj.dtoList = [];
              obj.endTime = this.form.endTime;
              obj.roomOrderId = a.roomOrderId;
              obj.roomStatus = this.fix_infoType == 7 ? 3 : this.fix_infoType;
              obj.memberType = n == 0 ? this.form.memberType : 0;
              obj.remarks = this.form.desc;
              obj.roomBedId = a.bedId;
              obj.roomId = a.roomId;
              data.editList.push(obj);
            });
            this.confirmCheckData.domains.forEach((a) => {
              let cNum = 0;
              let oNum = 0;
              this.colleaguesData.forEach((b) => {
                if (a.customerId != b.customerId) {
                  cNum += 1;
                }
                if (a.roomOrderId != b.roomOrderId) {
                  oNum += 1;
                }
              });
              if (this.colleaguesData.length == cNum) {
                data.customerIds.push(a.customerId);
              }
              if (this.colleaguesData.length == oNum) {
                data.roomOrderIdList.push(a.roomOrderId);
              }
            });
          }
          onModificationCheckout(JSON.stringify(data)).then((res) => {
            if (Number(res.code) === 0) {
              this.$message({ type: 'success', message: '修改成功' });
              this.formDialogVisible = false;
              this.lookBookDialog = false;
              this.todayDialog = false;
              this.detailDialogVisible = false;
              this.bedDialogVisible = false;
              this.roomDialogVisible = false;
              if (this.radio1 === '远期') {
                this.is_submit = false;
                this.currentPage = 1;
                this.onGetRoomListData();
              } else {
                this.activeIndex = '5';
                this.onChangeOverlap('实时', this.activeIndex);
              }
              this.todaySwitchPageNum(1);
            } else {
              console.log(res);
            }
          });
        }
      });
    },
    // 置脏房间
    onSetDirtyRoom(scope, id) {
      const roomOrBedId = this.titleStatus == 1 ? scope === undefined ? id : scope.roomId : scope === undefined ? id : scope.bedId;
      const data = {
        roomId: roomOrBedId,
        roomOrBed: this.titleStatus == 1 ? 1 : 2
      };
      onSetDirtyRoom(data).then((res) => {
        if (res.code == 0) {
          this.$message({ type: 'success', message: '成功' });
          if (this.radio1 === '远期') {
            this.is_submit = false;
            this.currentPage = 1;
            this.onGetRoomListData();
          } else {
            this.onChangeOverlap('实时', this.activeIndex);
          }
        } else {
          this.$message(res.msg);
        }
      });
    },
    // 置净房间
    onCleanRoomFun(scope, id) {
      const roomOrBedId = this.titleStatus == 1 ? scope === undefined ? id : scope.roomId : scope === undefined ? id : scope.bedId;
      const data = {
        roomId: roomOrBedId,
        roomOrBed: this.titleStatus == 1 ? 1 : 2
      };
      onCleanRoomFun(data).then((res) => {
        if (res.code == 0) {
          this.$message({ type: 'success', message: '成功' });
          if (this.radio1 === '远期') {
            this.is_submit = false;
            this.currentPage = 1;
            this.onGetRoomListData();
          } else {
            this.onChangeOverlap('实时', this.activeIndex);
          }
        } else {
          this.$message(res.msg);
        }
      });
    },
    roomSettlement(row) {
      if (this.Lib.checkPower('beauty-2-ftdd') == false) return;
      if (!row.orderId) return;
      this.$router.push({
        name: 'stage-orderSettlement',
      });
      window.sessionStorage.settlementOrderId = row.orderId;
    },
    // 确认是否使用
    isConfirmCheckIn(item) {
      if (this.Lib.checkPower('beauty-2-xzsy') == false) return;
      this.nameStatus = 2;
      this.fix_infoType = item.roomStatus == '已使用' ? 3 : item.roomStatus == '已预订' ? 2 : item.roomStatus == '已超时' ? 7 : item.roomStatus;
      this.fix_roomInfoId = item.roomInfoId ? item.roomInfoId : item.roomOrderId;
      this.detailDialogVisible = false;
      this.formTitle = '确认使用';
      this.formDialogVisible = true;
      this.form = {
        customerId: item.customerId,
        name: item.customerName,
        phone: item.customerPhone,
        now: dayjs().format('YYYY-MM-DD HH:mm'),
        endTime: item.endTime,
        roomOrderId: item.roomOrderId,
        memberType: item.memberType,
        chooseRoom: [
          [item.roomId, item.bedId]
        ],
        domains: [
          {
            customerId: item.customerId,
            roomId: item.roomId,
            beginTime: item.beginTime,
            endTime: item.endTime,
            roomOrderId: item.roomOrderId
          }
        ],
        dtoList: item.dtoList || [],
        desc: item.remarks
      };
      this.chooseRoomList = [item.roomId];
      this.confirmCheckData = JSON.parse(JSON.stringify(this.form));
      this.onGetUsableRoom(item.beginTime, item.endTime, item);
    },
    // 办理使用
    onConfirmCheckIn() {
      if (this.compareCurrentTimeVal(this.form.endTime) < 10) {
        this.$message('使用时间与预离时间间隔不能小于十分钟');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = {
            checkInList: [],
            customerIds: [],
            mainId: sessionStorage.getItem('mainId')
          };
          if (this.titleStatus == 1) {
            this.form.domains.forEach((a, n) => {
              this.colleaguesData.forEach((b, m) => {
                if (n === m) {
                  const obj = {};
                  obj.customerId = a.customerId;
                  obj.roomOrderId = a.roomOrderId;
                  obj.beginTime = this.form.now;
                  obj.customerId = a.customerId;
                  obj.customerName = this.form.name;
                  obj.customerPhone = this.form.phone;
                  obj.customerType = m == 0 ? 0 : 1;
                  const nArr = [{ name: (b.name || '同行顾客'), phone: b.phone }];
                  b.chooseList.forEach((c) => {
                    if (c.name == '') {
                      c.name = '同行顾客';
                    }
                    nArr.push(c);
                  });
                  obj.dtoList = (m == 0 ? b.chooseList : nArr);
                  obj.endTime = this.form.endTime;
                  obj.roomOrderId = a.roomOrderId;
                  obj.mainId = sessionStorage.getItem('mainId');
                  obj.memberType = m == 0 ? this.form.memberType : 0;
                  obj.remarks = this.form.desc;
                  obj.roomBedId = '';
                  obj.roomId = b.roomId;
                  data.checkInList.push(obj);
                }
              });
            });
            this.confirmCheckData.dtoList.forEach((n) => {
              let num = 0;
              this.colleaguesData[0].chooseList.forEach((m) => {
                if (n.customerId !== m.customerId) {
                  num += 1;
                }
              });
              if (num == this.colleaguesData[0].chooseList.length) {
                data.customerIds.push(n.customerId);
              }
            });
          } else {
            this.colleaguesData.forEach((a, n) => {
              const obj = {};
              obj.customerId = a.customerId;
              obj.roomOrderId = a.roomOrderId;
              obj.beginTime = this.form.now;
              obj.customerId = a.customerId;
              obj.customerName = a.name || '同行顾客';
              obj.customerPhone = a.phone;
              obj.customerType = n == 0 ? 0 : 1;
              obj.dtoList = [];
              obj.endTime = this.form.endTime;
              obj.roomOrderId = a.roomOrderId;
              obj.mainId = sessionStorage.getItem('mainId');
              obj.memberType = n == 0 ? this.form.memberType : 0;
              obj.remarks = this.form.desc;
              obj.roomBedId = a.bedId;
              obj.roomId = a.roomId;
              data.checkInList.push(obj);
            });
            this.confirmCheckData.domains.forEach((a) => {
              let cNum = 0;
              this.colleaguesData.forEach((b) => {
                if (a.customerId != b.customerId) {
                  cNum += 1;
                }
              });
              if (this.colleaguesData.length == cNum) {
                if (a.customerType == 1) {
                  data.customerIds.push(a.customerId);
                }
              }
            });
          }
          onBookToCheckin(JSON.stringify(data)).then((res) => {
            if (Number(res.code) === 0) {
              if (this.radio1 === '远期') {
                sessionStorage.setItem('date_range', this.date_range);
                this.is_submit = false;
                this.currentPage = 1;
                this.onGetRoomListData();
              } else {
                this.activeIndex = '5';
                this.onChangeOverlap('实时', this.activeIndex);
              }
              this.detailDialogVisible = false;
              this.formDialogVisible = false;
              this.lookBookDialog = false;
              this.orderInfoDialog = false;
              this.$message({
                showClose: true,
                message: '成功',
                type: 'success'
              });
              this.todaySwitchPageNum(1);
            }
          });
        }
      });
    },
    // 锁定房间
    onLockupRoomFun(scope, column, roomId, roomBedId) {
      if (this.Lib.checkPower('beauty-2-sf') == false) return;
      const data = {
        roomId,
        roomBedId,
        lockDate: scope === undefined ? dayjs().format('YYYY-MM-DD') : `${column.label.substring(0, 10)}`,
        mainId: sessionStorage.getItem('mainId')
      };
      onLockUpRoom(data).then((res) => {
        if (res.code === 0) {
          this.$message({ type: 'success', message: '成功' });
          if (this.radio1 === '远期') {
            this.is_submit = false;
            this.currentPage = 1;
            this.onGetRoomListData();
          } else {
            this.onChangeOverlap('实时', this.activeIndex);
          }
        } else {
          console.log(res);
        }
      });
    },
    // 解锁房间
    onUnlockRoom(scope, column, id) {
      if (this.Lib.checkPower('beauty-2-sf') == false) return;
      let data;
      if (scope != undefined) {
        if (this.titleStatus == 1) {
          const tempArr = scope.timeDatas.filter((x) => x.today === column.label.substring(0, 10));
          const tempArrTwo = JSON.parse(JSON.stringify(tempArr[0])).roomInfos.find(
            (x) => x.roomStatus === 1
          );
          tempArr[0].roomInfos[0] = tempArrTwo;
          data = {
            roomOrderId: tempArr[0].roomInfos[0].roomOrderId,
            mainId: sessionStorage.getItem('mainId')
          };
        } else {
          let newInfoId = '';
          scope.bedInfoList.forEach((a) => {
            if (a.dateTime == column.label.substring(0, 10)) {
              newInfoId = a.roomOrderId;
            }
          });
          data = {
            roomOrderId: newInfoId,
            mainId: sessionStorage.getItem('mainId')
          };
        }
      } else {
        data = {
          roomOrderId: id,
          mainId: sessionStorage.getItem('mainId')
        };
      }
      onUnlockRoom(data).then((res) => {
        if (res.code === 0) {
          this.$message({ type: 'success', message: '成功' });
          if (this.radio1 === '远期') {
            this.is_submit = false;
            this.currentPage = 1;
            this.onGetRoomListData();
          } else {
            this.onChangeOverlap('实时', this.activeIndex);
          }
        } else {
          console.log(res);
        }
      });
    },
    // 退房
    onCheckOutRoom() {
      onCheckOutRoom(this.chooseOutBedList).then((res) => {
        if (Number(res.code) === 0) {
          if (this.radio1 === '远期') {
            this.is_submit = false;
            this.currentPage = 1;
            this.onGetRoomListData();
          } else {
            this.onChangeOverlap('实时', this.activeIndex);
          }
          this.detailDialogVisible = false;
          this.bedDialogVisible = false;
          this.roomDialogVisible = false;
          this.outRoomdialog = false;
          this.orderInfoDialog = false;
          this.$message({
            type: 'success',
            message: this.titleStatus == 1 ? '退房成功!' : '退位成功!'
          });
        } else {
          console.log(res);
        }
      });
    },
    // 点击单元格
    clickCellEvent(row, column, cell, event) {
      let num = 0;
      this.dropdown_type = 2;
      if (this.titleStatus != 1) {
        if (column.label) {
          if (row.roomOrBed == 1) {
            row.bedInfoList.forEach((a) => {
              if (a.dateTime == column.label.substring(0, 10)) {
                num = a.bookPepNum;
              }
            });
          } else {
            row.bedInfoList.forEach((a) => {
              if (a.dateTime == column.label.substring(0, 10)) {
                num = a.checkInNum || a.bookPepNum;
              }
            });
          }
        } else {
          num = 1;
        }
      }
      this.dropdown_num = num;
      if (column.label && this.titleStatus != 1) {
        row.bedInfoList.forEach((a) => {
          if (a.dateTime == column.label.substring(0, 10)) {
            this.dropdown_type = a.roomStatus;
          }
        });
      } else {
        let nNum = 0;
        if (column.label) {
          row.timeDatas.forEach((a) => {
            if (a.today == column.label.substring(0, 10)) {
              this.dropdown_type = a.roomInfos.length > 0 ? a.roomInfos[0].roomStatus : 2;
            } else {
              nNum += 1;
            }
          });
          if (nNum == row.timeDatas.length) {
            this.dropdown_type = 0;
          }
        }
      }
      if (column.label && new Date(column.label.substring(0, 10)).getTime() >= new Date(dayjs().format('YYYY-MM-DD')).getTime()) {
        this.lockRoomStatus = 1;
      } else {
        this.lockRoomStatus = 2;
      }
      if (!column.label || new Date(column.label.substring(0, 10)).getTime() >= new Date(dayjs().format('YYYY-MM-DD')).getTime()) {
        this.dropdown_x = `${event.clientX}px`;
        this.dropdown_y = `${event.clientY}px`;
        this.showDropdown_vis = true;
        this.dropdown_row = row;
        this.dropdown_col = column;
        this.showDetailButton = true;
      } else if (new Date(column.label.substring(0, 10)).getTime() < new Date(dayjs().format('YYYY-MM-DD')).getTime() && !cell.style.background && this.titleStatus == 1) {
        this.showDropdown_vis = false;
        this.showDetailButton = false;
      } else if (this.dropdown_num == 0 && this.titleStatus != 1) {
        this.showDropdown_vis = false;
        this.showDetailButton = false;
      } else {
        this.dropdown_x = `${event.clientX}px`;
        this.dropdown_y = `${event.clientY}px`;
        this.showDropdown_vis = true;
        this.dropdown_row = row;
        this.dropdown_col = column;
        this.showDetailButton = true;
      }
      if (this.titleStatus == 1) {
        switch (cell.style.background) {
        // 0 锁房  1 已使用 2预订 3离店
          case 'rgb(254, 240, 241)':
            this.table_button_status = 0;
            break;
          case 'linear-gradient(-30deg, rgb(75, 156, 254), rgb(117, 180, 255))':
            this.table_button_status = 1;
            break;
          case 'linear-gradient(-30deg, rgb(255, 190, 53), rgb(252, 225, 101))':
            this.table_button_status = 2;
            break;
          case 'white':
            this.table_button_status = 1;
            break;
          case 'linear-gradient(-30deg, rgb(124, 126, 255), rgb(143, 146, 255))':
            this.table_button_status = 2;
            break;
          case '#f5f7fa':
            this.table_button_status = 2;
            break;
          default:
            this.table_button_status = 99;
            break;
        }
      } else {
        switch (row.roomOrBed) {
          case 1:
            this.table_button_status = 11;
            break;
          default:
            this.table_button_status = 22;
            break;
        }
        if (cell.style.background) {
          this.table_add = 1;
        } else {
          this.table_add = 2;
        }
      }
    },
    // 新增预订或新增使用
    onBookingOrCheckIn(title, roomId, bedId, item) {
      if (title == '新增预订') {
        if (this.Lib.checkPower('beauty-2-xzyd') == false) return;
      }
      if (title == '新增使用') {
        if (this.Lib.checkPower('beauty-2-xzsy') == false) return;
      }
      this.nameStatus = 1;
      setTimeout(() => {
        this.$refs.form.clearValidate();
        this.colleaguesData = [];
      }, 100);
      this.formTitle = title;
      this.formDialogVisible = true;
      this.fix_infoType = null;
      this.fix_roomInfoId = null;
      this.showDropdown_vis = false;
      let newNow = '';
      if (item) {
        if (item.endTime) {
          if (dayjs().isAfter(dayjs(item.endTime, 'day'))) {
            newNow = dayjs().format('YYYY-MM-DD HH:mm');
          } else {
            newNow = item.endTime;
          }
        } else {
          newNow = dayjs().format('YYYY-MM-DD HH:mm');
        }
      } else {
        newNow = dayjs().format('YYYY-MM-DD HH:mm');
      }
      this.form = {
        name: '',
        phone: '',
        now: newNow,
        endTime: '',
        chooseRoom: bedId ? [[roomId, bedId]] : [],
        domains: [
          {
            roomId
          }
        ],
        desc: ''
      };
      if (roomId) {
        this.chooseRoomList = [roomId];
      } else {
        this.chooseRoomList = [];
      }
      this.onGetUsableRoom(dayjs().format('YYYY-MM-DD HH:mm'), dayjs().add(10, 'minute').format('YYYY-MM-DD HH:mm'), item);
    },
    // 确定并开单
    onConfirmOrder() {
      if (this.Lib.checkPower('beauty-2-ftdd') == false) return;
      const arr = [];
      if (this.titleStatus == 1) {
        this.form.domains.forEach((a, n) => {
          this.colleaguesData.forEach((b, m) => {
            if (n === m) {
              const obj = {};
              obj.customerId = a.customerId;
              obj.roomOrderId = a.roomOrderId;
              obj.beginTime = this.form.now;
              obj.customerId = a.customerId;
              obj.customerName = this.form.name;
              obj.customerPhone = this.form.phone;
              obj.customerType = m == 0 ? 0 : 1;
              const nArr = [{ name: (b.name || '同行顾客'), phone: b.phone }];
              b.chooseList.forEach((c) => {
                if (c.name == '') {
                  c.name = '同行顾客';
                }
                nArr.push(c);
              });
              obj.dtoList = (m == 0 ? b.chooseList : nArr);
              obj.endTime = this.form.endTime;
              obj.roomOrderId = a.roomOrderId;
              obj.mainId = sessionStorage.getItem('mainId');
              obj.memberType = m == 0 ? this.form.memberType : 0;
              obj.remarks = this.form.desc;
              obj.roomBedId = '';
              obj.roomId = b.roomId;
              obj.roomName = b.roomName;
              arr.push(obj);
            }
          });
        });
      } else {
        this.colleaguesData.forEach((a, n) => {
          const obj = {};
          obj.customerId = a.customerId;
          obj.roomOrderId = a.roomOrderId;
          obj.beginTime = this.form.now;
          obj.customerName = a.name || '同行顾客';
          obj.customerPhone = a.phone;
          obj.customerType = n == 0 ? 0 : 1;
          obj.dtoList = [];
          obj.endTime = this.form.endTime;
          obj.roomOrderId = a.roomOrderId;
          obj.mainId = sessionStorage.getItem('mainId');
          obj.memberType = n == 0 ? this.form.memberType : 0;
          obj.remarks = this.form.desc;
          obj.bedNum = a.bedNum;
          obj.roomBedId = a.bedId;
          obj.roomId = a.roomId;
          obj.roomName = a.roomName;
          arr.push(obj);
        });
      }
      const obj = {};
      const roomInfo = this.form;
      obj.beginTime = roomInfo.now;
      obj.buySource = 0;
      obj.customerName = roomInfo.name;
      obj.customerPhone = roomInfo.phone;
      obj.endTime = roomInfo.endTime;
      obj.roomOrderId = roomInfo.roomOrderId;
      obj.memberType = roomInfo.memberType;
      obj.roomId = roomInfo.domains[0].roomId;
      obj.roomInfosList = arr;
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.bookOrderId = '';
      this.$router.push({
        name: 'stage-serviceBilling',
        params: {
          form: obj
        }
      });
    },
    // 新增使用
    onFormToCheckIn() {
      if (!this.validateTime(this.form.now, this.form.endTime)) {
        this.$message({
          showClose: true,
          message: '时间选择有误或超时,请重新选择时间',
          type: 'error'
        });
        this.form.endTime = '';
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.compareCurrentTimeVal(this.form.endTime) < 10) {
            this.$message('预使用时间与预离时间间隔不能小于十分钟');
            return;
          }
          const data = {
            checkInList: [],
            customerIds: [],
            mainId: sessionStorage.getItem('mainId')
          };
          if (this.titleStatus == 1) {
            this.form.domains.forEach((a, n) => {
              this.colleaguesData.forEach((b, m) => {
                if (n === m) {
                  const obj = {};
                  obj.customerId = a.customerId;
                  obj.roomOrderId = a.roomOrderId;
                  obj.beginTime = this.form.now;
                  obj.customerName = this.form.name;
                  obj.customerPhone = this.form.phone;
                  obj.customerType = m == 0 ? 0 : 1;
                  const nArr = [{ name: (b.name || '同行顾客'), phone: b.phone }];
                  b.chooseList.forEach((c) => {
                    if (c.name == '') {
                      c.name = '同行顾客';
                    }
                    nArr.push(c);
                  });
                  obj.dtoList = (m == 0 ? b.chooseList : nArr);
                  obj.endTime = this.form.endTime;
                  obj.mainId = sessionStorage.getItem('mainId');
                  obj.memberType = m == 0 ? this.form.memberType : 0;
                  obj.remarks = this.form.desc;
                  obj.roomBedId = '';
                  obj.roomId = b.roomId;
                  data.checkInList.push(obj);
                }
              });
            });
          } else {
            this.colleaguesData.forEach((a, n) => {
              const obj = {};
              obj.customerId = a.customerId;
              obj.roomOrderId = a.roomOrderId;
              obj.beginTime = this.form.now;
              obj.customerName = a.name || '同行顾客';
              obj.customerPhone = a.phone;
              obj.customerType = n == 0 ? 0 : 1;
              obj.dtoList = [];
              obj.endTime = this.form.endTime;
              obj.mainId = sessionStorage.getItem('mainId');
              obj.memberType = n == 0 ? this.form.memberType : 0;
              obj.remarks = this.form.desc;
              obj.roomBedId = a.bedId;
              obj.roomId = a.roomId;
              data.checkInList.push(obj);
            });
          }

          onBookToCheckin(JSON.stringify(data)).then((res) => {
            if (Number(res.code) === 0) {
              this.$message({ type: 'success', message: '新增成功' });
              this.formDialogVisible = false;
              this.detailDialogVisible = false;
              this.bedDialogVisible = false;
              this.roomDialogVisible = false;
              this.outRoomdialog = false;
              if (this.radio1 === '远期') {
                this.is_submit = false;
                this.currentPage = 1;
                this.onGetRoomListData();
              } else {
                this.activeIndex = '5';
                this.onChangeOverlap('实时', this.activeIndex);
              }
              this.todaySwitchPageNum(1);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 返回是否是当天入离
    returnClock(scope, date) {
      if (scope.row.timeDatas.length != 0) {
        const temp = scope.row.timeDatas.find((x) => x.today === date);
        if (temp != undefined) {
          let num = 0;
          temp.roomInfos.forEach((a) => {
            if (a.roomStatus === 6) {
              num++;
            }
          });
          if (num > 0) {
            return true;
          }
        }
      }
    },
    // 返回是否重复预订
    returnOverlap(scope, date) {
      if (scope.row.timeDatas.length != 0) {
        const temp = scope.row.timeDatas.find((x) => x.today === date);
        if (temp != undefined) {
          let num = 0;
          temp.roomInfos.forEach((a) => {
            if (a.isOverly === 1) {
              num++;
            }
          });
          if (num > 0) {
            return true;
          }
        }
      }
    },
    // 返回是否锁房
    returnLockRoom(scope, date) {
      if (this.titleStatus == 1) {
        if (scope.row.timeDatas.length != 0) {
          const temp = scope.row.timeDatas.find((x) => x.today === date);
          if (temp != undefined) {
            let num = 0;
            temp.roomInfos.forEach((a) => {
              if (a.roomStatus == 1) {
                num++;
              }
            });
            if (num > 0) {
              return true;
            }
          }
        }
      } else {
        const temp = scope.row.bedInfoList.find((x) => x.dateTime === date);
        return temp.roomStatus == 1;
      }
    },
    // 打开日期选择器
    showDatePicker() {
      this.showDropdown_vis = false;
      this.$refs.main_table.bodyWrapper.scrollLeft = 0;
      setTimeout(() => {
        this.$refs.saveDateInput.handleFocus();
      }, 300);
    },
    // 筛选里的房间名搜索
    screenInputSearch() {
      // this.screen_display = false;
      if (this.radio1 === '实时') {
        this.activeIndex = '5';
        this.onChangeOverlap('实时');
      } else {
        this.is_submit = false;
        this.currentPage = 1;
        this.onGetRoomListData();
      }
    },
    // 筛选重置
    resetScreen() {
      this.resetStatus = true;
      setTimeout(() => {
        this.resetStatus = false;
      }, 1000);
      this.screen_minute = 0;
      this.screen_radio = '分';
      this.screen_roomName = '';
      this.screenInputSearch();
    },
    test3(count) {
      this.$refs[`search_input${count}`][0].blur();
    },
    changePhone(val) {
      if (this.Lib.CheckPhone(val) == false) {
        return;
      }
      const data = {
        mainId: window.sessionStorage.mainId,
        sex: '',
        memberType: 1,
        grade: '',
        rate: '',
        birthdayStart: '',
        birthdayEnd: '',
        source: '',
        pageNum: 1,
        pageSize: 10,
        phone: val,
        isAsc: true
      };
      getCustomerMsgList(data).then((res) => {
        const arr = res.data.records;
        if (res.code == 0) {
          const cName = arr
            ? arr.length > 0
              ? arr[0].customerName
                ? arr[0].customerName
                : ''
              : ''
            : '';
          this.nameStatus = cName ? 2 : 1;
          this.form.name = cName || this.form.name;
          this.form.memberType = arr[0].memberType;
          // this.$refs.form.validate();
        } else {
          console.log(res);
        }
      });
    },
    // 切换实时房态和远期房态
    onChangeOverlap(val, option) {
      const vm = this;
      this.showDropdown_vis = false;
      // this.checkinRoomsList = {};
      // option 1 代表从右上角点击的事件
      if (option == 999) {
        this.deleteAllScreenData();
      }
      if (val === '实时') {
        let minute;
        switch (this.screen_radio) {
          case '分':
            minute = this.screen_minute;
            break;
          case '时':
            minute = this.screen_minute * 60;
            break;
          case '天':
            minute = this.screen_minute * 1440;
            break;
          default:
            break;
        }
        this.checkinRoomsList = [];
        this.loading = true;
        if (this.titleStatus == 1) {
          const data = {
            mainId: sessionStorage.getItem('mainId'),
            state: Number(this.activeIndex),
            minute: minute === 0 ? null : minute,
            roomName: this.screen_roomName // 搜索房间
          };
          oncheckNowStatus(data).then((res) => {
            res.data.checkinRoomsList.forEach((list) => {
            // 这两个字段用于倒计时
              list.startTimeStamp = new Date().getTime();
              list.endTimeStamp = new Date(list.endTime).getTime();
            });
            vm.checkinRoomsList = res.data.checkinRoomsList;
            this.count1 = res.data.count1;
            this.count2 = res.data.count2;
            this.count3 = res.data.count3;
            this.count4 = res.data.count4;
            this.count5 = res.data.count5;
            this.count6 = res.data.count6;
            this.count7 = res.data.count7;
            this.count8 = res.data.count8;
            this.shishitab = false;
            setTimeout(() => {
              this.shishitab = true;
            }, 10);
            setTimeout(() => {
              this.loading = false;
            }, 10);
          // this.$refs['shishitab'].$forceUpdate();
          });
        } else {
          const data = {
            mainId: sessionStorage.getItem('mainId'),
            state: Number(this.activeIndex),
            minute: minute === 0 ? null : minute,
            bedNumber: this.screen_roomName || null // 搜索房间
          };
          getRealTimeBed(data).then((res) => {
            res.data.checkinRoomsList.forEach((list) => {
            // 这两个字段用于倒计时
              list.startTimeStamp = new Date().getTime();
              list.endTimeStamp = new Date(list.endTime).getTime();
            });
            vm.checkinRoomsList = res.data.checkinRoomsList;
            this.count1 = res.data.count1;
            this.count2 = res.data.count2;
            this.count3 = res.data.count3;
            this.count4 = res.data.count4;
            this.count5 = res.data.count5;
            this.count6 = res.data.count6;
            this.count7 = res.data.count7;
            this.count8 = res.data.count8;
            this.shishitab = false;
            setTimeout(() => {
              this.shishitab = true;
            }, 10);
            setTimeout(() => {
              this.loading = false;
            }, 300);
          // this.$refs['shishitab'].$forceUpdate();
          });
        }
      } else {
        this.$refs.saveDateInput.handleClose();
        sessionStorage.setItem('date_range', this.date_range);
        this.is_submit = false;
        this.currentPage = 1;
        this.onGetRoomListData();
      }
    },
    // 切换实时房态类型
    handleSelect() {
      if (this.radio1 === '远期') {
        sessionStorage.setItem('date_range', this.date_range);
        this.is_submit = false;
        this.currentPage = 1;
        this.onGetRoomListData();
      } else {
        this.onChangeOverlap('实时');
      }
    },
    // 返回实时房态颜色
    returnShiShi(item) {
      switch (item.state) {
        case 6:
          // 锁定
          return { background: 'linear-gradient(-30deg,rgba(255,93,93,1),rgba(255,130,130,1))' };
        case 1:
          // 预订
          return { background: 'linear-gradient(-30deg,rgba(255,190,53,1),rgba(252,225,101,1))' };
        case 3:
          // 使用
          return { background: 'linear-gradient(-30deg,rgba(75,156,254,1),rgba(117,180,255,1))' };
        case 4:
          // 1锁定 2已预订 3已使用 4置脏 5已离店 -1置净
          if (item.roomStatus === 1) {
            return { background: 'linear-gradient(-30deg,rgba(255,93,93,1),rgba(255,130,130,1))' };
          } if (item.roomStatus === 2) {
            return { background: 'linear-gradient(-30deg,rgba(255,190,53,1),rgba(252,225,101,1))' };
          } if (item.roomStatus === 3) {
            if (item.endTime === dayjs().format('YYYY-MM-DD')) {
              return { background: 'linear-gradient(-30deg,rgba(75,156,254,1),rgba(117,180,255,1))' };
            }
            return { background: 'linear-gradient(-30deg,rgba(53,214,138,1),rgba(93,226,155,1))' };
          } if (!item.roomStatus) {
            return { background: 'linear-gradient(-30deg,rgba(53,214,138,1),rgba(93,226,155,1))' };
          } if (item.roomStatus === 7) {
            return { background: 'linear-gradient(-30deg,rgba(124,126,255,1),rgba(143,146,255,1))' };
          }
          break;
        case 5:
          // 1锁定 2已预订 3已使用 4置脏 5已离店 -1置净
          if (item.roomStatus === 1) {
            return { background: 'linear-gradient(-30deg,rgba(255,93,93,1),rgba(255,130,130,1))' };
          } if (item.roomStatus === 2) {
            return { background: 'linear-gradient(-30deg,rgba(255,190,53,1),rgba(252,225,101,1))' };
          } if (item.roomStatus === 3) {
            // if (item.endTime === dayjs().format("YYYY-MM-DD")) {
            return { background: 'linear-gradient(-30deg,rgba(75,156,254,1),rgba(117,180,255,1))' };
            // } else {
            //   return {
            //     background: "linear-gradient(-30deg,rgba(53,214,138,1),rgba(93,226,155,1))",
            //   };
            // }
          } if (item.roomStatus === 7) {
            return { background: 'linear-gradient(-30deg,rgba(124,126,255,1),rgba(143,146,255,1))' };
          }
          return { background: 'linear-gradient(-30deg,rgba(53,214,138,1),rgba(93,226,155,1))' };
        case 7:
          // 1锁定 2已预订 3已使用 4置脏 5已离店 6已过期 -1置净
          if (item.roomStatus === 1) {
            return { background: 'linear-gradient(-30deg,rgba(255,93,93,1),rgba(255,130,130,1))' };
          } if (item.roomStatus === 2) {
            return { background: 'linear-gradient(-30deg,rgba(255,190,53,1),rgba(252,225,101,1))' };
          } if (item.roomStatus === 3) {
            // if (item.endTime === dayjs().format("YYYY-MM-DD")) {
            return { background: 'linear-gradient(-30deg,rgba(75,156,254,1),rgba(117,180,255,1))' };
            // } else {
            // return {
            //     background:
            //         "linear-gradient(-30deg,rgba(53,214,138,1),rgba(93,226,155,1))"
            // };
            // }
          } if (item.roomStatus === 7) {
            return { background: 'linear-gradient(-30deg,rgba(124,126,255,1),rgba(143,146,255,1))' };
          }
          if (!item.roomStatus || item.roomStatus === 6) {
            return { background: 'linear-gradient(-30deg,rgba(53,214,138,1),rgba(93,226,155,1))' };
          }
          break;
        case 8:
          // 1锁定 2已预订 3已使用 4置脏 5已离店 -1置净
          if (item.roomStatus === 1) {
            return { background: 'linear-gradient(-30deg,rgba(255,93,93,1),rgba(255,130,130,1))' };
          } if (item.roomStatus === 2) {
            return { background: 'linear-gradient(-30deg,rgba(255,190,53,1),rgba(252,225,101,1))' };
          } if (item.roomStatus === 3) {
            if (item.endTime === dayjs().format('YYYY-MM-DD')) {
              return { background: 'linear-gradient(-30deg,rgba(75,156,254,1),rgba(117,180,255,1))' };
            }
            return { background: 'linear-gradient(-30deg,rgba(53,214,138,1),rgba(93,226,155,1))' };
          } if (item.roomStatus === 7) {
            return { background: 'linear-gradient(-30deg,rgba(124,126,255,1),rgba(143,146,255,1))' };
          }
          if (!item.roomStatus) {
            return { background: 'linear-gradient(-30deg,rgba(53,214,138,1),rgba(93,226,155,1))' };
          }
          break;

        default:
          return { background: 'linear-gradient(-30deg,rgba(53,214,138,1),rgba(93,226,155,1))' };
      }
    },
    // 房间或者床位--点击退房按钮
    roomOutList(item) {
      if (this.Lib.checkPower('beauty-2-tftw') == false) return;
      const data = {
        roomOrderId: item.roomOrderId,
        mainId: sessionStorage.getItem('mainId')
      };
      this.outRoomdialog = true;
      this.chooseOutBedList = [];
      getCheckOutDetails(data).then((res) => {
        if (res.code == 0) {
          this.outRoomOrBedList = res.data;
          this.outRoomOrBedList.dtoList.forEach((a) => {
            if (a.customerName === item.customerName) {
              a.disable = true;
              this.chooseOutBedList.push(a);
              setTimeout(() => {
                this.$refs.outRoomTable.toggleRowSelection(a);
              }, 0);
            } else {
              a.disable = false;
            }
          });
        } else {
          console.log();
        }
      });
    },
    // 5.10  勾选禁用判断
    checkSelectable(row) {
      return !row.disable;
    },
    chooseOutBed(val) {
      this.chooseOutBedList = val;
    },
    // 确认是否退房
    onConfrimCheckOut(item) {
      this.$confirm(
        `该顾客入离日期为 ${item.beginTime} 至 ${item.endTime
        }，共 ${item.dateTime}，确定要${this.titleStatus == 1 ? '退房' : '退位'}吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.chooseOutBedList = [{ roomOrderId: item.roomOrderId, mainId: sessionStorage.getItem('mainId') }];
        this.onCheckOutRoom();
      });
    },
    // 取消预订
    onCancelCheckIn(item) {
      if (this.Lib.checkPower('beauty-2-qxyd') == false) return;
      this.$confirm('是否取消预订？取消后数据不可恢复，请谨慎操作！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        onCancleBooking({
          roomOrderId: item.roomOrderId
        }).then(() => {
          this.$message({
            type: 'success',
            message: '已成功取消预订'
          });
          this.lookBook(this.lookBookObj, this.lookBookstatus);
          // this.detailDialogVisible = false;
          // this.bedDialogVisible = false;
          // this.roomDialogVisible = false;
          // this.outRoomdialog = false;
          // this.todayDialog = false;
          if (this.radio1 === '实时') {
            this.activeIndex = '5';
            this.onChangeOverlap('实时');
            this.todaySwitchPageNum(1);
          } else {
            this.is_submit = false;
            this.currentPage = 1;
            this.onGetRoomListData();
          }
        });
      }).catch(() => { });
    },
    // 导出房间信息
    onGetRoomDataExcel() {
      if (this.Lib.checkPower('beauty-2-ftdcfjxx') == false) return;
      window.location.href = `${this.Lib.A()}/room/export/writeExcel?beginTime=${this.date_range[0]
      }&endTime=${this.date_range[1]}&mainId=${sessionStorage.getItem('mainId')}`;
    },
    // 打开顾客列表
    onShowPhoneBook() {
      this.bookVisible = true;
    },
    // 选择完顾客列表的回调
    checkMember(phone, name, memberType) {
      const { form } = this;
      form.name = name;
      form.phone = phone;
      form.memberType = memberType;
      this.nameStatus = 2;
      this.starStatus = 2;
      if (this.titleStatus == 1) {
        const arr = [];
        this.form.domains.forEach((a) => {
          this.room_List.forEach((b) => {
            if (a.roomId == b.id) {
              const obj = {};
              obj.customerId = a.customerId;
              obj.roomOrderId = a.roomOrderId;
              obj.roomId = b.id;
              obj.roomName = b.name;
              obj.bedId = '';
              obj.bedNum = '';
              obj.phone = phone;
              obj.name = name;
              obj.chooseList = [];
              arr.push(obj);
            }
          });
        });
        this.colleaguesData = arr;
      }
      // 下面这个注释是解决jira265问题--刚从顾客列表中选择顾客还没按保存，就校验结果
      // this.$refs.form.validate();
    },
    // 预使用时间————返回禁用时间
    disabledDate(time) {
      if (this.form.now) {
        // console.log(dayjs().isAfter(dayjs(this.form.now, "day")))
        if (dayjs().isAfter(dayjs(this.form.now, 'day'))) {
          this.selectableRange = `${dayjs(this.form.now).format('HH:mm:ss')} - 23:59:59`;
          this.form.now = dayjs().format('YYYY-MM-DD HH:mm');
        } else {
          this.selectableRange = '00:00:00 - 23:59:59';
        }
      }
      return time.getTime() < Date.now() - 8.64e7;
    },
    // 预离时间————返回禁用时间
    disabledLeaveDate(time) {
      if (dayjs().isAfter(dayjs(this.form.endTime, 'day'))) {
        this.selectableLeaveRange = `${dayjs(this.form.endTime).add(10, 'minute').format('HH:mm:ss')} - 23:59:59`;
        this.form.endTime = dayjs().add(10, 'minute').format('YYYY-MM-DD HH:mm');
      } else {
        this.selectableLeaveRange = '00:00:00 - 23:59:59';
      }
      return time.getTime() < dayjs(this.form.now).valueOf() - 8.64e7;
    },
    editLeaveDate() {
      if ((dayjs(this.form.endTime).valueOf() * 1 - dayjs(this.form.now).valueOf() * 1) < 0) {
        this.form.endTime = dayjs(this.form.now).add(10, 'minute').format('YYYY-MM-DD HH:mm');
      }
      this.onGetUsableRoom(this.form.now, this.form.endTime);
    },
    // 当预使用时间 获得焦点时 清除预离时间
    pickerChange() {
      this.form.endTime = '';
    },
    // 选择房间列表的房间
    roomInfoChange() {
      const arr = [];
      const arrTwo = [];
      this.chooseRoomList.forEach((a, n) => {
        this.room_List.forEach((b) => {
          if (a == b.id) {
            const obj = {};
            obj.customerId = a.customerId;
            obj.roomOrderId = a.roomOrderId;
            obj.roomId = b.id;
            obj.roomName = b.name;
            obj.bedId = '';
            obj.bedNum = '';
            obj.phone = this.colleaguesData[n] ? this.colleaguesData[n].phone : '';
            obj.name = this.colleaguesData[n] ? this.colleaguesData[n].name : '';
            obj.chooseList = this.colleaguesData[n] ? this.colleaguesData[n].chooseList : [];
            arr.push(obj);
            const objTwo = {};
            objTwo.peopleNumber = 0;
            objTwo.roomId = b.id;
            arrTwo.push(objTwo);
          }
        });
      });
      this.form.domains = arrTwo;
      this.colleaguesData = arr;
    },
    // 计算服务时长
    onGetLastedTime(time) {
      const millisecond = dayjs(time).diff(
        dayjs(this.form.now),
        'millisecond'
      );
      // const dateBegin = new Date(this.form.now);
      // const dateEnd = new Date(this.form.endTime);
      // 计算相差天数
      let dayDiff = Math.floor(millisecond / (24 * 3600 * 1000)); // 计算出相差天数
      if (dayDiff < 0) dayDiff++;
      // 计算相差小时数
      const leave1 = millisecond % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
      const hours = Math.floor(leave1 / (3600 * 1000)); // 计算出小时数
      // 计算相差分钟数
      const leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
      const minutes = Math.floor(leave2 / (60 * 1000)); // 计算相差分钟数
      return `共${dayDiff || ''}${dayDiff ? '天' : ''}${hours || ''
      }${hours ? '小时' : ''}${minutes || 0}分钟`;
    },
    // 比较当前时间--并输出相差多少分钟
    compareCurrentTimeVal(time) {
      // const data = new Date();
      // const month = data.getMonth() < 9 ? `0${data.getMonth() + 1}` : data.getMonth() + 1;
      // const date = data.getDate() <= 9 ? `0${data.getDate()}` : data.getDate();
      // const hour = data.getHours();
      // const minute = data.getMinutes() < 10 ? `0${data.getMinutes()}` : data.getMinutes();
      // const second = data.getSeconds() < 10 ? `0${data.getSeconds()}` : data.getSeconds();
      // const currentDate = `${data.getFullYear()}-${month}-${date} ${hour}:${minute}:${second}`;
      // const millisecond = dayjs(time).diff(
      //     dayjs(currentDate),
      //     "millisecond"
      // )
      const millisecond = dayjs(time).diff(
        dayjs(this.form.now),
        'millisecond'
      );
      // const dateEnd = new Date(time);
      // 计算相差天数
      const dayDiff = Math.floor(millisecond / (24 * 3600 * 1000)); // 计算出相差天数
      // 计算相差小时数
      const leave1 = millisecond % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
      const hours = Math.floor(leave1 / (3600 * 1000)); // 计算出小时数
      // 计算相差分钟数
      const leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
      const minutes = Math.floor(leave2 / (60 * 1000)); // 计算相差分钟数
      return Math.floor((dayDiff || 0) * 1440 + (hours || 0) * 60 + (minutes || 0) * 1);
    },
    // 判断表单的时间是否满足需求
    validateTime(beginTime, endTime) {
      if (!dayjs().isBefore(dayjs(endTime))) {
        return false;
      }
      return true;
    },
    // 清空筛选的数据
    deleteAllScreenData() {
      this.currentPage = 1;
      this.screen_roomName = '';
      this.screen_minute = 0;
      this.screen_radio = '分';
      this.activeIndex = '5';
    }
  }
};
</script>
<style lang="less" scoped>
/* 5.10 */
.rbInfo {
  padding: 10px 0;
  p {
    padding: 0 10px;
    padding-bottom: 10px;
    font-size: 13px;
    color: #333;
  }
  .rbTitle {
    font-weight: bold;
  }
  .rbBorder {
    border-bottom: 1px solid #EDEFF3;
  }
  .rbBtn {
    padding: 10px 10px 0 10px;
  }
}
.bedList{
  min-height: 240px;
  display: flex;
  ul {
    list-style-type: none;
    .fangda {
      margin: 0;
      border: 10px solid #fff;
      border-radius: 0px;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.3);
    }
    li {
      background: #FFFFFF;
      float: left;
      width: 128px;
      height: 160px;
      border-radius: 10px;
      margin: 10px;
      padding: 20px;
      cursor: pointer;
      position: relative;
      .ssbedChoose {
        width: 128px;
        height: 160px;
        padding: 20px;
        margin: -20px 0 0 -20px;
        border-radius: 10px;
        position: absolute;
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        display:table-cell;
        text-align:center;
        vertical-align:middle;
        z-index: 99;
        .ssbtn {
          margin: 0 0 10px 0;
        }
      }
      h1 {
        height: 24px;
        line-height: 24px;
        font-size: 24px;
        padding-bottom: 20px;
        font-weight: bold;
        color: #FFFFFF;
      }
      h2 {
        height: 36px;
        line-height: 18px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
      }
      h3 {
        width: 100px;
        height: 32px;
        line-height: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        text-align: left;
        display: flex;
        align-items: center;
        position: relative;
        i {
          position: absolute;
          font-size: 22px;
          margin-left: 107px;
        }
      }
      h4 {
        padding-top: 30px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  p {
    width: 100%;
    text-align: center;
    height: 223px;
    line-height: 223px;
    padding-bottom: 17px;
    color: #333;
    font-size: 14px;
  }
}
.starPhoneClass {
  position: absolute;
  font-size: 18px;
  margin-top: -53px;
  margin-left: 161px;
  background-color: #fff;
  width: 33px;
  user-select: none;
}
.starPhoneDisabled {
  position: absolute;
  font-size: 14px;
  margin-top: -62px;
  margin-left: 120px;
  background-color: #f5f7fa;
  color: #c0c4cc;
  width: 208px;
  height: 38px;
  line-height: 38px;
  padding: 0 15px;
  cursor: not-allowed;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  user-select: none;
  span {
    float: left;
  }
  samp {
    line-height: 40px;
    float: left;
    font-size: 18px;
  }
}
.first_header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  .room_type {
    display: flex;
    font-size: 14px;
    div {
      display: flex;
      align-items: center;
      margin-left: 10px;

      @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
        margin-left: 5px;
      }

      &:nth-child(1) {
        margin-left: 0px;
      }
      .room_type_color {
        width: 25px;
        height: 25px;
        @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
          width: 20px;
          height: 20px;
        }
        border-radius: 2px;
      }
      .room_type_border {
        border: 1px solid #DFE6EC;
      }
      span {
        margin-left: 10px;
        white-space: nowrap;
        @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
          font-size: 11px;
        }
      }
      .iconfont {
        @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
          font-size: 25px !important;
        }
      }
    }
  }
  .first_header_button {
    display: flex;
    margin-right: 20px;
    height: 42px;
    line-height: 42px;
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
      margin-right: 10px;
    }
    p {
      color: #333;
      font-size: 14px;
      float: left;
      padding-left: 20px;
      cursor: pointer;
      i {
        color: #999;
        padding-right: 5px;
        float: left;
      }
    }
  }
}

.el-dropdown-link {
  width: 100%;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dropdown,
.el-table {
  color: inherit;
}
.el-dialog__header {
  border-bottom: initial;
}
.time_clock {
  position: absolute;
  bottom: -1px;
  right: 3px;
  font-size: 20px;
}
.roomTd {
  font-size: 12px;
  height: 14px;
  line-height: 14px;
}
.person_clock {
  position: absolute;
  bottom: 0;
  right: 26px;
  font-size: 20px;
}
.person_clock {
  position: absolute;
  bottom: 0;
  right: 26px;
  font-size: 20px;
}
.el-input__prefix {
  padding-left: 100px !important;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: red;
}
.el-table__row td {
  cursor: pointer !important;
}
.el-input__prefix {
  left: 12px;
}
.el-input__icon {
  margin-left: 10px !important;
}
.el-icon-date:before {
  padding-left: 10px !important;
}
.header_room {
  color: #fd5c8c;
  font-weight: 600;
}
.cell_name {
  position: relative;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.shishi_room_list {
  list-style: none;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  //   justify-content: space-between;
  .shishi_room_list_item {
    width: 328px;
    height: 198px;
    border-radius: 10px;
    position: relative;
    margin-right: 16px;
    margin-bottom: 10px;
    color: white;
    overflow: hidden;
    .ssbedChoose {
      width: 288px;
      height: 158px;
      padding: 20px;
      border-radius: 10px;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      display:table-cell;
      text-align:center;
      vertical-align:middle;
      z-index: 99;
      .ssbtn {
        display: block;
        margin: 10px auto;
      }
    }
    p {
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
      word-break: break-all;
      cursor: pointer;
    }
    p:nth-child(2) {
      font-size: 16px;
      padding-top: 20px;
    }
    p:nth-child(3) {
      font-size: 14px;
      padding-top: 8px;
    }
    p:nth-child(4) {
      font-size: 14px;
      padding-top: 43px;
    }
    .shishi_room_button_list {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;
      align-content: center;
      // background: rgba(0, 0, 0, 0.1);
      .shishi_room_button_left_list {
        display: flex;
        align-items: center;
        img {
          cursor: pointer;
        }
      }
      .shishi_room_button_right_list {
        display: flex;
        align-items: center;
        span {
          display: block;
          width: 40px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: white;
          font-size: 18px;
          color: #218757;
          border-radius: 100px;
          cursor: pointer;
        }
        span + span {
          margin-left: 20px;
        }
      }
    }
  }
}
.timer /deep/ i {
  font-style: normal;
}
.no_data {
  text-align: center;
  padding: 30px;
  margin: 10px;
  margin-top: 0px;
  border: solid 1px #d8dce5;
  span {
    font-size: 14px;
    color: #999999;
    margin-top: 17px;
  }
}
.dropdown_dif {
  display: block;
  position: absolute;
  z-index: 9999999;
  list-style: none;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  li {
    list-style: none;
    line-height: 36px;
    padding: 0 20px;
    margin: 0;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    outline: none;
  }
}
.suoding {
  background-color: #fcebec;
  color: #fd6b7e;
}
.yuding {
  background-color: #fcf6e8;
  color: #febc5e !important;
}
.ruzhu {
  background-color: #def3f4;
  color: #26c6ce;
}
.lidian {
  background-color: #f8f8f8;
  color: #a7a7a7;
}
.future_booking {
  font-size: 12px;
  color: #666;
}
.futureIcon {
  position: absolute;
  right: 0;
  bottom: 0;
  i {
    font-size: 20px;
    color: #B4BCCC;
    position: relative;
    right: 5px;
    bottom: 5px;
  }
}
.detail_table {
  border-collapse: collapse;
  width: 100%;
  thead {
    tr {
      th {
        background: #f5f7fa;
        color: #818691;
        font-size: 14px;
        padding: 16px;
        font-weight: bold;
      }
    }
  }
  tbody {
    &::before {
      content: "";
      height: 20px;
      clear: both;
      display: table;
    }
    tr {
      border-left: 1px solid rgba(230, 235, 245, 1);
      border-right: 1px solid rgba(230, 235, 245, 1);
      border-bottom: 1px dashed rgba(230, 235, 245, 1);
      &:last-of-type {
        border-bottom: 1px solid rgba(230, 235, 245, 1);
      }
      &:first-of-type {
        border-top: 1px solid rgba(230, 235, 245, 1);
        white-space: nowrap;
        td {
          padding: 12px 16px;
        }
      }
      td {
        padding: 16px;
      }
    }
  }
}
.checked_in_tip {
  position: absolute;
  right: 10px;
  bottom: 16px;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
}
/* 5.10 */
.footFixed {
  position: fixed;
  background-color: #fff;
  height: 50px;
  line-height: 50px;
  border-top: 1px solid #EEEEEE;
  margin-left: -30px;
  padding-left: 30px;
  bottom: 0;
  z-index: 3;
  p {
    float: left;
    font-size: 14px;
    color: #333;
    padding-right: 30px;
    cursor: pointer;
    i {
      font-size: 20px;
      color: #B4BCCC;
      padding-right: 5px;
      position: relative;
      top: 2px;
    }
  }
  h5 {
    float: right;
    font-size: 14px;
    color: #333;
    padding-right: 30px;
    cursor: pointer;
    i {
      font-size: 20px;
      color: #B4BCCC;
      padding-right: 5px;
      position: relative;
      top: 2px;
    }
  }
}
.diaFrinfo {
  float: right;
  font-size: 18px;
  line-height: 40px;
}
.tableExpandList {
  list-style: none;
  .li {
    padding-left: 220px;
    height: 53px;
    line-height: 53px;
    border-bottom: 1px solid #e6ebf5;
    .tinputOne {
      width: 150px;
      margin: 0 20px 0 10px;
    }
    .tinputTwo {
      width: 150px;
      margin: 0 10px 0 10px;
    }
    i {
      font-size: 26px;
      position: relative;
      top: 4px;
      color: #989C98;
      cursor: pointer;
    }
  }
  .li:last-child {
    border-bottom: 0;
  }
}
</style>
<style>
.deduction .el-table__expand-icon {
  display: none;
}
.deduction .el-table__expanded-cell {
  padding: 0 !important;
}
.deduction .el-dialog__body {
  overflow: hidden !important;
}
.el-picker-panel__footer button:first-child {
  display: none;
}
.cell > div > div > span > .el-icon-date:before {
  padding-left: 14px;
}
.hover-row {
  background-color: #fff !important;
}
body .el-table th.gutter {
  display: table-cell !important;
}

body .el-table colgroup.gutter {
  display: table-cell !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
p > .el-button + .el-button {
  margin-left: -7px;
}
.el-radio-group {
  white-space: nowrap;
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .el-input__inner {
    margin-top: 1px;
  }
}
.first_header2 {
  position: relative;
  clear: both;
  height: 64px;
}
.first_header2_icon,
.first_header2_icon > p {
  display: flex;
  align-items: center;
}
.first_header2 .el-tabs__nav-wrap::after {
  height: 0;
}
.first_header2_right {
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  top: 0;
}
.first_header2_right > .first_header_button {
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 42px;
  line-height: 42px;
}
.first_header2_right > .first_header_button p {
  color: #333;
  font-size: 14px;
  float: left;
  padding-left: 20px;
  cursor: pointer;
}
.first_header2_right > .first_header_button p i {
  color: #999;
  padding-right: 5px;
  float: left;
}
.first_header2
  > .el-tabs
  > .el-tabs__header
  > .el-tabs__nav-wrap
  > .el-tabs__nav-scroll {
  height: 50px;
}
.first_header_button > button {
  height: 41px;
}
/* 5.10 */
.footFixed {
  width: calc(100vw - 155px) !important;
}
</style>
